import axios from 'axios';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var Configuration = /** @class */ (function () {
    /**
     * @ignore
     * not part of public api, don't include in generated docs
     */
    function Configuration() {
        this.defaultConfig = {
            baseApiUrl: 'https://api.ordercloud.io',
            apiVersion: 'v1',
            timeoutInMilliseconds: 60 * 1000,
            clientID: null,
            cookieOptions: {
                samesite: 'lax',
                secure: false,
                domain: null,
                prefix: 'ordercloud',
                path: '/', // accessible on any path in the domain
            },
        };
        this.config = cloneDeep(this.defaultConfig);
        this.Set = this.Set.bind(this);
        this.Get = this.Get.bind(this);
    }
    Configuration.prototype.Set = function (config) {
        this.config = __assign(__assign(__assign({}, this.defaultConfig), this.config), (config || {}));
        this.config.cookieOptions = __assign(__assign(__assign({}, this.defaultConfig.cookieOptions), this.config.cookieOptions), ((config === null || config === void 0 ? void 0 : config.cookieOptions) || {}));
    };
    Configuration.prototype.Get = function () {
        return this.config;
    };
    return Configuration;
}());
// takes an object and creates a new one with same properties/values
// useful so we don't mutate original object
function cloneDeep(obj) {
    return JSON.parse(JSON.stringify(obj));
}
var Configuration$1 = new Configuration();

var OrderCloudError = /** @class */ (function (_super) {
    __extends(OrderCloudError, _super);
    function OrderCloudError(ex) {
        var _this = this;
        var errors = safeParseErrors(ex); // extract ordercloud errors from response
        var firstError = errors === null || errors === void 0 ? void 0 : errors[0]; // most of the time there is just one error
        _this = _super.call(this, getMessage(ex, firstError)) || this;
        _this.isOrderCloudError = true;
        _this.errors = errors;
        _this.name = 'OrderCloudError';
        _this.errorCode = getErrorCode(firstError);
        _this.status = ex.response.status;
        _this.statusText = ex.response.statusText;
        _this.response = ex.response;
        _this.request = ex.request;
        return _this;
    }
    return OrderCloudError;
}(Error));
/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
function safeParseErrors(ex) {
    var _a;
    try {
        var value = (_a = ex === null || ex === void 0 ? void 0 : ex.response) === null || _a === void 0 ? void 0 : _a.data;
        if (!value) {
            return [];
        }
        if (typeof value === 'object') {
            return value.Errors;
        }
        if (typeof value === 'string') {
            // axios sometimes returns a string, so we must deserialize it ourselves
            if (value && value.charCodeAt(0) === 65279) {
                // there seems to be a BOM character at the beginning
                // of this string that causes json parsing to fail
                value = value.substring(1);
            }
            var data = JSON.parse(value);
            return data.Errors;
        }
        return value;
    }
    catch (e) {
        return [];
    }
}
/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
function getMessage(ex, error) {
    if (!error) {
        return ex.response.statusText;
    }
    switch (error.ErrorCode) {
        case 'NotFound':
            return "".concat(error.Data.ObjectType, " ").concat(error.Data.ObjectID, " not found");
        default:
            return error.Message;
    }
}
/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
function getErrorCode(error) {
    if (!error) {
        return 'OrderCloudError';
    }
    return error.ErrorCode;
}

/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
var CookieApi = /** @class */ (function () {
    function CookieApi() {
    }
    CookieApi.prototype.write = function (name, value, options) {
        if (value === void 0) { value = undefined; }
        document.cookie = this.buildCookieString(name, value, options);
    };
    CookieApi.prototype.read = function (name) {
        var rows = document.cookie.split(';');
        for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
            var row = rows_1[_i];
            var _a = row.split('='), key = _a[0], val = _a[1];
            var cookieKey = decodeURIComponent(key.trim().toLowerCase());
            if (cookieKey === name.toLowerCase()) {
                return decodeURIComponent(val);
            }
        }
        return '';
    };
    // dont use this method - only making public so I can test the cookie string
    // document.cookie only returns name=value pairs, not expiration or any other options set on create
    CookieApi.prototype.buildCookieString = function (name, value, options) {
        if (value === void 0) { value = undefined; }
        var expires;
        if (!value) {
            expires = new Date('Thu, 01 Jan 1970 00:00:00 GMT');
            value = '';
        }
        else {
            // set expiration of cookie longer than token
            // so we can parse clientid from token to perform refresh when token has expired
            expires = new Date();
            expires.setFullYear(expires.getFullYear() + 1);
        }
        var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        str += options.domain ? ';domain=' + options.domain : '';
        str += expires ? ';expires=' + expires.toUTCString() : '';
        str += options.secure ? ';secure' : '';
        str += options.samesite ? ';samesite=' + options.samesite : '';
        str += options.path ? ';path=' + options.path : '';
        // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum 4096 bytes per cookie
        var cookieLength = str.length + 1;
        if (cookieLength > 4096) {
            console.warn("Cookie ".concat(name, " possibly not set or overflowed because it was too large! (").concat(cookieLength, " > 4096 bytes)"));
        }
        return str;
    };
    return CookieApi;
}());
var cookie = new CookieApi();

/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
var CookieService = /** @class */ (function () {
    function CookieService() {
        this.get = this.get.bind(this);
        this.set = this.set.bind(this);
        this.remove = this.remove.bind(this);
    }
    CookieService.prototype.get = function (name) {
        var configuration = Configuration$1.Get();
        var cookieName = configuration.cookieOptions.prefix + name;
        return cookie.read(cookieName);
    };
    CookieService.prototype.set = function (name, cookieVal) {
        var configuration = Configuration$1.Get();
        var cookieName = configuration.cookieOptions.prefix + name;
        cookie.write(cookieName, cookieVal, configuration.cookieOptions);
    };
    CookieService.prototype.remove = function (name) {
        var configuration = Configuration$1.Get();
        var cookieName = configuration.cookieOptions.prefix + name;
        cookie.write(cookieName, undefined, configuration.cookieOptions);
    };
    return CookieService;
}());
var cookies = new CookieService();

/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
function decodeBase64(str) {
    // atob is defined on the browser, in node we must use buffer
    if (typeof atob !== 'undefined') {
        return atob(str);
    }
    return Buffer.from(str, 'base64').toString('binary');
}
/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
function parseJwt(token) {
    try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(decodeBase64(base64)
            .split('')
            .map(function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); })
            .join(''));
        return JSON.parse(jsonPayload);
    }
    catch (e) {
        throw new Error('Invalid token');
    }
}

/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
var paramsSerializer = {
    serialize: customSerializer,
};
/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
function customSerializer(originalParams) {
    var params = JSON.parse(JSON.stringify(originalParams)); // don't mutate original object
    var valuesArray = [];
    // serialize filters first, they are handled specially
    if (params.filters) {
        var filters = flattenFiltersObject(params.filters);
        var _loop_1 = function (key) {
            var filterVal = filters[key];
            if (Array.isArray(filterVal)) {
                filterVal.forEach(function (val) {
                    return valuesArray.push("".concat(key, "=").concat(encodeURIComponent(val)));
                });
            }
            // exclude null, undefined, or empty string but permit boolean false, and 0 to be serialized
            else if (typeof filterVal === 'boolean' || filterVal === 0 || filterVal) {
                valuesArray.push("".concat(key, "=").concat(encodeURIComponent(filterVal)));
            }
        };
        for (var key in filters) {
            _loop_1(key);
        }
        delete params.filters;
    }
    // serialize the rest of the params
    for (var key in params) {
        var val = params[key];
        if (val) {
            valuesArray.push("".concat(key, "=").concat(encodeURIComponent(val)));
        }
    }
    return valuesArray.length ? "".concat(valuesArray.join('&')) : '';
}
/**
 * @ignore
 * not part of public api, don't include in generated docs
 *
 * build a flattened filters object  where each key is the dot-referenced property
 * to filter and the value is the value to filter by
 * this ultimately gets sent to ordercloud as a query param
 */
function flattenFiltersObject(filters) {
    var result = {};
    for (var key in filters) {
        inspectProp(filters[key], key, result);
    }
    return result;
}
/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
function inspectProp(propVal, propName, result) {
    var isObject = Object.prototype.toString.call(propVal) === '[object Object]';
    if (isObject) {
        for (var key in propVal) {
            inspectProp(propVal[key], "".concat(propName, ".").concat(key), result);
        }
    }
    else {
        if (propVal === null) {
            throw new Error("Null is not a valid filter prop. Use negative filter \"!\" combined with wildcard filter \"*\" to define a filter for the absence of a value. \nex: an order list call with { xp: { hasPaid: '!*' } } would return a list of orders where xp.hasPaid is null or undefined\nhttps://ordercloud.io/features/advanced-querying#filtering");
        }
        result[propName] = propVal;
    }
}

var Auth = /** @class */ (function () {
    function Auth() {
        if (typeof axios === 'undefined') {
            throw new Error('Ordercloud is missing required peer dependency axios. This must be installed and loaded before the OrderCloud SDK');
        }
        /**
         * @ignore
         * not part of public api, don't include in generated docs
         */
        this.Anonymous = this.Anonymous.bind(this);
        this.ClientCredentials = this.ClientCredentials.bind(this);
        this.ElevatedLogin = this.ElevatedLogin.bind(this);
        this.Login = this.Login.bind(this);
        this.RefreshToken = this.RefreshToken.bind(this);
    }
    /**
     * @description this workflow is most appropriate for client apps where user is a human, ie a registered user
     *
     * @param username of the user logging in
     * @param password of the user logging in
     * @param client_id of the application the user is logging into
     * @param scope optional roles being requested, if omitted will return all assigned roles
     * @param customRoles optional custom roles being requested - string array
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Auth.prototype.Login = function (username, password, clientID, scope, customRoles, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _scope, body, configuration, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (scope && !Array.isArray(scope)) {
                            throw new Error('scope must be a string array');
                        }
                        if (customRoles != null && !Array.isArray(customRoles)) {
                            throw new Error('custom roles must be defined as a string array');
                        }
                        if ((scope === null || scope === void 0 ? void 0 : scope.length) && !(customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = scope.join(' ');
                        }
                        else if (!(scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope += " ".concat(customRoles.join(' '));
                        }
                        else if ((scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = "".concat(scope.join(' '), " ").concat(customRoles.join(' '));
                        }
                        body = {
                            grant_type: 'password',
                            username: username,
                            password: password,
                            client_id: clientID,
                            scope: _scope,
                        };
                        configuration = Configuration$1.Get();
                        return [4 /*yield*/, axios
                                .post("".concat(configuration.baseApiUrl, "/oauth/token"), paramsSerializer.serialize(body), __assign({ headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                }, adapter: configuration.axiosAdapter }, requestOptions))
                                .catch(function (e) {
                                if (e.response) {
                                    throw new OrderCloudError(e);
                                }
                                throw e;
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * @description similar to login except client secret is also required, adding another level of security
     *
     * @param clientSecret of the application
     * @param username of the user logging in
     * @param password of the user logging in
     * @param clientID of the application the user is logging into
     * @param scope roles being requested - space delimited string or array
     * @param customRoles optional custom roles being requested - string array
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Auth.prototype.ElevatedLogin = function (clientSecret, username, password, clientID, scope, customRoles, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _scope, body, configuration, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (scope && !Array.isArray(scope)) {
                            throw new Error('scope must be a string array');
                        }
                        if (customRoles != null && !Array.isArray(customRoles)) {
                            throw new Error('custom roles must be defined as a string array');
                        }
                        if ((scope === null || scope === void 0 ? void 0 : scope.length) && !(customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = scope.join(' ');
                        }
                        else if (!(scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope += " ".concat(customRoles.join(' '));
                        }
                        else if ((scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = "".concat(scope.join(' '), " ").concat(customRoles.join(' '));
                        }
                        body = {
                            grant_type: 'password',
                            scope: _scope,
                            client_id: clientID,
                            username: username,
                            password: password,
                            client_secret: clientSecret,
                        };
                        configuration = Configuration$1.Get();
                        return [4 /*yield*/, axios
                                .post("".concat(configuration.baseApiUrl, "/oauth/token"), paramsSerializer.serialize(body), __assign({ headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                }, adapter: configuration.axiosAdapter }, requestOptions))
                                .catch(function (e) {
                                if (e.response) {
                                    throw new OrderCloudError(e);
                                }
                                throw e;
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * @description this workflow is best suited for a backend system
     *
     * @param clientSecret of the application
     * @param clientID of the application the user is logging into
     * @param scope roles being requested - space delimited string or array
     * @param customRoles optional custom roles being requested - string array
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Auth.prototype.ClientCredentials = function (clientSecret, clientID, scope, customRoles, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _scope, body, configuration, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (scope && !Array.isArray(scope)) {
                            throw new Error('scope must be a string array');
                        }
                        if (customRoles != null && !Array.isArray(customRoles)) {
                            throw new Error('custom roles must be defined as a string array');
                        }
                        if ((scope === null || scope === void 0 ? void 0 : scope.length) && !(customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = scope.join(' ');
                        }
                        else if (!(scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope += " ".concat(customRoles.join(' '));
                        }
                        else if ((scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = "".concat(scope.join(' '), " ").concat(customRoles.join(' '));
                        }
                        body = {
                            grant_type: 'client_credentials',
                            scope: _scope,
                            client_id: clientID,
                            client_secret: clientSecret,
                        };
                        configuration = Configuration$1.Get();
                        return [4 /*yield*/, axios
                                .post("".concat(configuration.baseApiUrl, "/oauth/token"), paramsSerializer.serialize(body), __assign({ headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                }, adapter: configuration.axiosAdapter }, requestOptions))
                                .catch(function (e) {
                                if (e.response) {
                                    throw new OrderCloudError(e);
                                }
                                throw e;
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * @description extend your users' session by getting a new access token with a refresh token. refresh tokens must be enabled in the dashboard
     *
     * @param refreshToken of the application
     * @param clientID of the application the user is logging into
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Auth.prototype.RefreshToken = function (refreshToken, clientID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var body, configuration, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = {
                            grant_type: 'refresh_token',
                            client_id: clientID,
                            refresh_token: refreshToken,
                        };
                        configuration = Configuration$1.Get();
                        return [4 /*yield*/, axios
                                .post("".concat(configuration.baseApiUrl, "/oauth/token"), paramsSerializer.serialize(body), __assign({ headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                }, adapter: configuration.axiosAdapter }, requestOptions))
                                .catch(function (e) {
                                if (e.response) {
                                    throw new OrderCloudError(e);
                                }
                                throw e;
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * @description allow users to browse your catalog without signing in - must have anonymous template user set in dashboard
     *
     * @param clientID of the application the user is logging into
     * @param scope roles being requested - space delimited string or array
     * @param customRoles optional custom roles being requested - string array
     * @param requestOptions.anonuserid Provide an externally generated id to track this user session, used specifically for the tracking events feature for integrating with Send and Discover
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Auth.prototype.Anonymous = function (clientID, scope, customRoles, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _scope, body, configuration, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (scope && !Array.isArray(scope)) {
                            throw new Error('scope must be a string array');
                        }
                        if (customRoles != null && !Array.isArray(customRoles)) {
                            throw new Error('custom roles must be defined as a string array');
                        }
                        if ((scope === null || scope === void 0 ? void 0 : scope.length) && !(customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = scope.join(' ');
                        }
                        else if (!(scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope += " ".concat(customRoles.join(' '));
                        }
                        else if ((scope === null || scope === void 0 ? void 0 : scope.length) && (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length)) {
                            _scope = "".concat(scope.join(' '), " ").concat(customRoles.join(' '));
                        }
                        body = {
                            grant_type: 'client_credentials',
                            client_id: clientID,
                            scope: _scope,
                        };
                        if (requestOptions.anonuserid) {
                            body['anonuserid'] = requestOptions.anonuserid;
                            delete requestOptions['anonuserid'];
                        }
                        configuration = Configuration$1.Get();
                        return [4 /*yield*/, axios
                                .post("".concat(configuration.baseApiUrl, "/oauth/token"), paramsSerializer.serialize(body), __assign({ headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                }, adapter: configuration.axiosAdapter }, requestOptions))
                                .catch(function (e) {
                                if (e.response) {
                                    throw new OrderCloudError(e);
                                }
                                throw e;
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return Auth;
}());
var Auth$1 = new Auth();

/**
 * @ignore
 * not part of public api, don't include in generated docs
 */
var isNode = new Function('try {return this===global;}catch(e){return false;}');
var Tokens = /** @class */ (function () {
    /**
     * @ignore
     * not part of public api, don't include in generated docs
     */
    function Tokens() {
        this.accessTokenCookieName = ".access-token";
        this.impersonationTokenCookieName = '.impersonation-token';
        this.refreshTokenCookieName = '.refresh-token';
        this.identityTokenCookieName = '.identity-token';
        this.accessToken = null;
        this.impersonationToken = null;
        this.refreshToken = null;
        this.identityToken = null;
        this.GetAccessToken = this.GetAccessToken.bind(this);
        this.GetImpersonationToken = this.GetImpersonationToken.bind(this);
        this.GetRefreshToken = this.GetRefreshToken.bind(this);
        this.RemoveAccessToken = this.RemoveAccessToken.bind(this);
        this.RemoveImpersonationToken = this.RemoveImpersonationToken.bind(this);
        this.SetAccessToken = this.SetAccessToken.bind(this);
        this.RemoveRefreshToken = this.RemoveRefreshToken.bind(this);
        this.SetImpersonationToken = this.SetImpersonationToken.bind(this);
        this.SetRefreshToken = this.SetRefreshToken.bind(this);
        this.RemoveIdentityToken = this.RemoveIdentityToken.bind(this);
        this.GetIdentityToken = this.GetIdentityToken.bind(this);
        this.SetIdentityToken = this.SetIdentityToken.bind(this);
        this._isTokenExpired = this._isTokenExpired.bind(this);
        this._tryRefreshToken = this._tryRefreshToken.bind(this);
    }
    /**
     * Manage Access Tokens
     */
    Tokens.prototype.GetAccessToken = function () {
        return isNode() ? this.accessToken : cookies.get(this.accessTokenCookieName);
    };
    Tokens.prototype.SetAccessToken = function (token) {
        parseJwt(token); // check if token is valid
        isNode()
            ? (this.accessToken = token)
            : cookies.set(this.accessTokenCookieName, token);
    };
    Tokens.prototype.RemoveAccessToken = function () {
        isNode()
            ? (this.accessToken = '')
            : cookies.remove(this.accessTokenCookieName);
    };
    /**
     * Manage Impersonation Tokens
     */
    Tokens.prototype.GetImpersonationToken = function () {
        return isNode()
            ? this.impersonationToken
            : cookies.get(this.impersonationTokenCookieName);
    };
    Tokens.prototype.SetImpersonationToken = function (token) {
        parseJwt(token); // check if token is valid
        isNode()
            ? (this.impersonationToken = token)
            : cookies.set(this.impersonationTokenCookieName, token);
    };
    Tokens.prototype.RemoveImpersonationToken = function () {
        isNode()
            ? (this.impersonationToken = null)
            : cookies.remove(this.impersonationTokenCookieName);
    };
    /**
     * Manage Refresh Tokens
     */
    Tokens.prototype.GetRefreshToken = function () {
        return isNode()
            ? this.refreshToken
            : cookies.get(this.refreshTokenCookieName);
    };
    Tokens.prototype.SetRefreshToken = function (token) {
        isNode()
            ? (this.refreshToken = token)
            : cookies.set(this.refreshTokenCookieName, token);
    };
    Tokens.prototype.RemoveRefreshToken = function () {
        isNode()
            ? (this.refreshToken = null)
            : cookies.remove(this.refreshTokenCookieName);
    };
    /**
     * Manage Identity Tokens
     */
    Tokens.prototype.GetIdentityToken = function () {
        return isNode()
            ? this.identityToken
            : cookies.get(this.identityTokenCookieName);
    };
    Tokens.prototype.SetIdentityToken = function (token) {
        isNode()
            ? (this.identityToken = token)
            : cookies.set(this.identityTokenCookieName, token);
    };
    Tokens.prototype.RemoveIdentityToken = function () {
        isNode()
            ? (this.identityToken = null)
            : cookies.remove(this.identityTokenCookieName);
    };
    /**
     * If no token is provided will attempt to get and validate token
     * stored in sdk. If token is invalid or missing it will also attempt
     * to refresh the token if possible
     */
    Tokens.prototype.GetValidToken = function (tokenToValidate) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = tokenToValidate || this.GetAccessToken();
                        if (!this._isTokenExpired(token)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._tryRefreshToken(token)];
                    case 1:
                        token = _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, Promise.resolve(token || '')];
                }
            });
        });
    };
    Tokens.prototype._isTokenExpired = function (token) {
        if (!token) {
            return true;
        }
        var decodedToken = parseJwt(token);
        var currentSeconds = Date.now() / 1000;
        var currentSecondsWithBuffer = currentSeconds - 10;
        return decodedToken.exp < currentSecondsWithBuffer;
    };
    Tokens.prototype._tryRefreshToken = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var refreshToken, sdkConfig, clientID, decodedToken, refreshRequest, accessToken_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        refreshToken = this.GetRefreshToken();
                        if (!refreshToken) {
                            return [2 /*return*/, accessToken || ''];
                        }
                        sdkConfig = Configuration$1.Get();
                        if (!accessToken && !sdkConfig.clientID) {
                            return [2 /*return*/, accessToken || ''];
                        }
                        if (accessToken) {
                            decodedToken = parseJwt(accessToken);
                            clientID = decodedToken.cid;
                        }
                        if (sdkConfig.clientID) {
                            clientID = sdkConfig.clientID;
                        }
                        if (!clientID) {
                            return [2 /*return*/, ''];
                        }
                        if (!clientID) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Auth$1.RefreshToken(refreshToken, clientID)];
                    case 2:
                        refreshRequest = _a.sent();
                        accessToken_1 = refreshRequest.access_token;
                        this.SetAccessToken(accessToken_1);
                        return [2 /*return*/, accessToken_1];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, ''];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Tokens;
}());
var tokenService = new Tokens();

var HttpClient = /** @class */ (function () {
    function HttpClient() {
        var _this = this;
        this.get = function (path, config) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeApiCall('get', path, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.post = function (path, config) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeApiCall('post', path, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.put = function (path, config) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeApiCall('put', path, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.patch = function (path, config) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeApiCall('patch', path, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.delete = function (path, config) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeApiCall('delete', path, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        if (typeof axios === 'undefined') {
            throw new Error('Missing required peer dependency axios. This must be installed and loaded before the OrderCloud SDK');
        }
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.post = this.post.bind(this);
        this.patch = this.patch.bind(this);
        this.delete = this.delete.bind(this);
        this._resolveToken = this._resolveToken.bind(this);
        this._buildRequestConfig = this._buildRequestConfig.bind(this);
        this._addTokenToConfig = this._addTokenToConfig.bind(this);
    }
    HttpClient.prototype.makeApiCall = function (verb, path, config) {
        return __awaiter(this, void 0, void 0, function () {
            var requestConfig, baseApiUrl, requestBody, response, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._buildRequestConfig(config)
                        // oauth endpoints unlike the rest don't have /{apiVersion}/ appended to them
                    ];
                    case 1:
                        requestConfig = _a.sent();
                        baseApiUrl = path.includes('oauth/')
                            ? "".concat(Configuration$1.Get().baseApiUrl, "/").concat(path)
                            : "".concat(Configuration$1.Get().baseApiUrl, "/").concat(Configuration$1.Get().apiVersion).concat(path);
                        if (!(verb === 'put' || verb === 'post' || verb === 'patch')) return [3 /*break*/, 3];
                        requestBody = requestConfig.data;
                        delete requestConfig.data;
                        return [4 /*yield*/, axios[verb](baseApiUrl, requestBody, requestConfig)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3: return [4 /*yield*/, axios[verb](baseApiUrl, requestConfig)];
                    case 4:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    // sets the token on every outgoing request, will attempt to
    // refresh the token if the token is expired and there is a refresh token set
    HttpClient.prototype._addTokenToConfig = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var token, validToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this._resolveToken(config);
                        return [4 /*yield*/, tokenService.GetValidToken(token)];
                    case 1:
                        validToken = _a.sent();
                        if (!config.headers) {
                            config.headers = {};
                        }
                        config.headers.Authorization = "Bearer ".concat(validToken);
                        return [2 /*return*/, config];
                }
            });
        });
    };
    HttpClient.prototype._resolveToken = function (config) {
        var token;
        if (config['accessToken']) {
            token = config['accessToken'];
        }
        else if (config['impersonating']) {
            token = tokenService.GetImpersonationToken();
        }
        else {
            token = tokenService.GetAccessToken();
        }
        // remove these custom parameters that axios doesn't understand
        // we were storing on the axios config for simplicity
        delete config['accessToken'];
        delete config['impersonating'];
        return token;
    };
    HttpClient.prototype._buildRequestConfig = function (config) {
        var sdkConfig = Configuration$1.Get();
        var requestConfig = __assign(__assign({}, config), { paramsSerializer: paramsSerializer, adapter: sdkConfig.axiosAdapter, timeout: sdkConfig.timeoutInMilliseconds, headers: {
                'Content-Type': 'application/json',
            } });
        return this._addTokenToConfig(requestConfig);
    };
    return HttpClient;
}());
var http = new HttpClient();

var SecurityProfiles = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SecurityProfiles() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of security profiles.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/securityprofiles", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new security profile. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/create|api docs} for more info
     *
     * @param securityProfile Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.Create = function (securityProfile, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/securityprofiles", __assign(__assign({}, requestOptions), { data: securityProfile, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single security profile.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/get|api docs} for more info
     *
     * @param securityProfileID ID of the security profile.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.Get = function (securityProfileID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/securityprofiles/".concat(securityProfileID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a security profile. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/save|api docs} for more info
     *
     * @param securityProfileID ID of the security profile.
     * @param securityProfile Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.Save = function (securityProfileID, securityProfile, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/securityprofiles/".concat(securityProfileID), __assign(__assign({}, requestOptions), { data: securityProfile, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a security profile.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/delete|api docs} for more info
     *
     * @param securityProfileID ID of the security profile.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.Delete = function (securityProfileID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/securityprofiles/".concat(securityProfileID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a security profile.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/patch|api docs} for more info
     *
     * @param securityProfileID ID of the security profile.
     * @param securityProfile
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.Patch = function (securityProfileID, securityProfile, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/securityprofiles/".concat(securityProfileID), __assign(__assign({}, requestOptions), { data: securityProfile, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a security profile assignment.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/delete-assignment|api docs} for more info
     *
     * @param securityProfileID ID of the security profile.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.supplierID ID of the supplier.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.DeleteAssignment = function (securityProfileID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/securityprofiles/".concat(securityProfileID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of security profile assignments.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/list-assignments|api docs} for more info
     *
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.supplierID ID of the supplier.
     * @param listOptions.securityProfileID ID of the security profile.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.commerceRole Commerce role of the security profile assignment. Possible values: Buyer, Seller, Supplier.
     * @param listOptions.level Level of the security profile assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/securityprofiles/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a security profile assignment.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/security-profiles/save-assignment|api docs} for more info
     *
     * @param securityProfileAssignment Required fields: SecurityProfileID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SecurityProfiles.prototype.SaveAssignment = function (securityProfileAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/securityprofiles/assignments", __assign(__assign({}, requestOptions), { data: securityProfileAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SecurityProfiles.As().List() // lists SecurityProfiles using the impersonated users' token
     */
    SecurityProfiles.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SecurityProfiles;
}());
var SecurityProfiles$1 = new SecurityProfiles();

var ForgottenPassword = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ForgottenPassword() {
        this.impersonating = false;
        this.SendVerificationCode = this.SendVerificationCode.bind(this);
        this.ResetPasswordByVerificationCode = this.ResetPasswordByVerificationCode.bind(this);
    }
    /**
     * Send a verification code. Sends a temporary verification code via email, which must subsequently be passed in a Reset Password call. The verification code expires in 120 minutes.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/forgotten-password/send-verification-code|api docs} for more info
     *
     * @param passwordResetRequest Required fields: ClientID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ForgottenPassword.prototype.SendVerificationCode = function (passwordResetRequest, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/password/reset", __assign(__assign({}, requestOptions), { data: passwordResetRequest, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Reset a password by verification code.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/forgotten-password/reset-password-by-verification-code|api docs} for more info
     *
     * @param verificationCode Verification code of the password reset.
     * @param passwordReset Required fields: ClientID, Username
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ForgottenPassword.prototype.ResetPasswordByVerificationCode = function (verificationCode, passwordReset, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/password/reset/".concat(verificationCode), __assign(__assign({}, requestOptions), { data: passwordReset, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ForgottenPassword.As().List() // lists ForgottenPassword using the impersonated users' token
     */
    ForgottenPassword.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ForgottenPassword;
}());
var ForgottenPassword$1 = new ForgottenPassword();

var ImpersonationConfigs = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ImpersonationConfigs() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of impersonation configs.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/impersonation-configs/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ImpersonationConfigs.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/impersonationconfig", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new impersonation config. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/impersonation-configs/create|api docs} for more info
     *
     * @param impersonationConfig Required fields: SecurityProfileID, ClientID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ImpersonationConfigs.prototype.Create = function (impersonationConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/impersonationconfig", __assign(__assign({}, requestOptions), { data: impersonationConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single impersonation config.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/impersonation-configs/get|api docs} for more info
     *
     * @param impersonationConfigID ID of the impersonation config.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ImpersonationConfigs.prototype.Get = function (impersonationConfigID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/impersonationconfig/".concat(impersonationConfigID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an impersonation config. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/impersonation-configs/save|api docs} for more info
     *
     * @param impersonationConfigID ID of the impersonation config.
     * @param impersonationConfig Required fields: SecurityProfileID, ClientID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ImpersonationConfigs.prototype.Save = function (impersonationConfigID, impersonationConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/impersonationconfig/".concat(impersonationConfigID), __assign(__assign({}, requestOptions), { data: impersonationConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an impersonation config.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/impersonation-configs/delete|api docs} for more info
     *
     * @param impersonationConfigID ID of the impersonation config.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ImpersonationConfigs.prototype.Delete = function (impersonationConfigID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/impersonationconfig/".concat(impersonationConfigID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an impersonation config.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/impersonation-configs/patch|api docs} for more info
     *
     * @param impersonationConfigID ID of the impersonation config.
     * @param impersonationConfig
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ImpersonationConfigs.prototype.Patch = function (impersonationConfigID, impersonationConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/impersonationconfig/".concat(impersonationConfigID), __assign(__assign({}, requestOptions), { data: impersonationConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ImpersonationConfigs.As().List() // lists ImpersonationConfigs using the impersonated users' token
     */
    ImpersonationConfigs.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ImpersonationConfigs;
}());
var ImpersonationConfigs$1 = new ImpersonationConfigs();

var Certs = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Certs() {
        this.impersonating = false;
        this.GetPublicKey = this.GetPublicKey.bind(this);
    }
    /**
     * Get a single cert public key. Returns a JSON Web Key (JWK). Can be used for validating the token was signed by OrderCloud.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/certs/get-public-key|api docs} for more info
     *
     * @param ID ID of the public key.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Certs.prototype.GetPublicKey = function (ID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("oauth/certs/".concat(ID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Certs.As().List() // lists Certs using the impersonated users' token
     */
    Certs.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Certs;
}());
var Certs$1 = new Certs();

var OpenIdConnects = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function OpenIdConnects() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of OpenID Connects.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/open-id-connects/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OpenIdConnects.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/openidconnects", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new OpenID Connect. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/open-id-connects/create|api docs} for more info
     *
     * @param openIdConnect Required fields: OrderCloudApiClientID, ConnectClientID, ConnectClientSecret, AppStartUrl, AuthorizationEndpoint, TokenEndpoint
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OpenIdConnects.prototype.Create = function (openIdConnect, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/openidconnects", __assign(__assign({}, requestOptions), { data: openIdConnect, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single OpenID Connect.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/open-id-connects/get|api docs} for more info
     *
     * @param openidconnectID ID of the openidconnect.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OpenIdConnects.prototype.Get = function (openidconnectID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/openidconnects/".concat(openidconnectID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a OpenID Connect. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/open-id-connects/save|api docs} for more info
     *
     * @param openidconnectID ID of the openidconnect.
     * @param openIdConnect Required fields: OrderCloudApiClientID, ConnectClientID, ConnectClientSecret, AppStartUrl, AuthorizationEndpoint, TokenEndpoint
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OpenIdConnects.prototype.Save = function (openidconnectID, openIdConnect, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/openidconnects/".concat(openidconnectID), __assign(__assign({}, requestOptions), { data: openIdConnect, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a OpenID Connect.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/open-id-connects/delete|api docs} for more info
     *
     * @param openidconnectID ID of the openidconnect.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OpenIdConnects.prototype.Delete = function (openidconnectID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/openidconnects/".concat(openidconnectID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a OpenID Connect.
     * Check out the {@link https://ordercloud.io/api-reference/authentication-and-authorization/open-id-connects/patch|api docs} for more info
     *
     * @param openidconnectID ID of the openidconnect.
     * @param openIdConnect
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OpenIdConnects.prototype.Patch = function (openidconnectID, openIdConnect, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/openidconnects/".concat(openidconnectID), __assign(__assign({}, requestOptions), { data: openIdConnect, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * OpenIdConnects.As().List() // lists OpenIdConnects using the impersonated users' token
     */
    OpenIdConnects.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return OpenIdConnects;
}());
var OpenIdConnects$1 = new OpenIdConnects();

var AdminUsers = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function AdminUsers() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of admin users.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-users/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUsers.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/adminusers", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new admin user. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-users/create|api docs} for more info
     *
     * @param user Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUsers.prototype.Create = function (user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/adminusers", __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single admin user.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-users/get|api docs} for more info
     *
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUsers.prototype.Get = function (userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/adminusers/".concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an admin user. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-users/save|api docs} for more info
     *
     * @param userID ID of the user.
     * @param user Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUsers.prototype.Save = function (userID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/adminusers/".concat(userID), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an admin user.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-users/delete|api docs} for more info
     *
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUsers.prototype.Delete = function (userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/adminusers/".concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an admin user.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-users/patch|api docs} for more info
     *
     * @param userID ID of the user.
     * @param user
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUsers.prototype.Patch = function (userID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/adminusers/".concat(userID), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * AdminUsers.As().List() // lists AdminUsers using the impersonated users' token
     */
    AdminUsers.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return AdminUsers;
}());
var AdminUsers$1 = new AdminUsers();

var AdminUserGroups = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function AdminUserGroups() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteUserAssignment = this.DeleteUserAssignment.bind(this);
        this.ListUserAssignments = this.ListUserAssignments.bind(this);
        this.SaveUserAssignment = this.SaveUserAssignment.bind(this);
    }
    /**
     * Get a list of admin user groups.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/usergroups", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new admin user group. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/create|api docs} for more info
     *
     * @param userGroup Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.Create = function (userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/usergroups", __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single admin user group.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/get|api docs} for more info
     *
     * @param userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.Get = function (userGroupID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/usergroups/".concat(userGroupID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an admin user group. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/save|api docs} for more info
     *
     * @param userGroupID ID of the user group.
     * @param userGroup Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.Save = function (userGroupID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/usergroups/".concat(userGroupID), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an admin user group.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/delete|api docs} for more info
     *
     * @param userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.Delete = function (userGroupID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/usergroups/".concat(userGroupID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an admin user group.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/patch|api docs} for more info
     *
     * @param userGroupID ID of the user group.
     * @param userGroup
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.Patch = function (userGroupID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/usergroups/".concat(userGroupID), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an admin user group user assignment.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/delete-user-assignment|api docs} for more info
     *
     * @param userGroupID ID of the user group.
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.DeleteUserAssignment = function (userGroupID, userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/usergroups/".concat(userGroupID, "/assignments/").concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of admin user group user assignments.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/list-user-assignments|api docs} for more info
     *
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.userID ID of the user.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.ListUserAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/usergroups/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an admin user group user assignment.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-user-groups/save-user-assignment|api docs} for more info
     *
     * @param userGroupAssignment Required fields: UserGroupID, UserID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminUserGroups.prototype.SaveUserAssignment = function (userGroupAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/usergroups/assignments", __assign(__assign({}, requestOptions), { data: userGroupAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * AdminUserGroups.As().List() // lists AdminUserGroups using the impersonated users' token
     */
    AdminUserGroups.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return AdminUserGroups;
}());
var AdminUserGroups$1 = new AdminUserGroups();

var AdminAddresses = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function AdminAddresses() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of admin addresses.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-addresses/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminAddresses.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/addresses", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new admin address. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-addresses/create|api docs} for more info
     *
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminAddresses.prototype.Create = function (address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/addresses", __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single admin address.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-addresses/get|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminAddresses.prototype.Get = function (addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an admin address. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-addresses/save|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminAddresses.prototype.Save = function (addressID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an admin address.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-addresses/delete|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminAddresses.prototype.Delete = function (addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an admin address.
     * Check out the {@link https://ordercloud.io/api-reference/seller/admin-addresses/patch|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    AdminAddresses.prototype.Patch = function (addressID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * AdminAddresses.As().List() // lists AdminAddresses using the impersonated users' token
     */
    AdminAddresses.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return AdminAddresses;
}());
var AdminAddresses$1 = new AdminAddresses();

var ApiClients = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ApiClients() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
        this.DeleteBuyerAssignment = this.DeleteBuyerAssignment.bind(this);
        this.DeleteSupplierAssignment = this.DeleteSupplierAssignment.bind(this);
    }
    /**
     * Get a list of API clients.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/apiclients", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new API client. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/create|api docs} for more info
     *
     * @param apiClient Required fields: AccessTokenDuration, AppName
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.Create = function (apiClient, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/apiclients", __assign(__assign({}, requestOptions), { data: apiClient, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single API client.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/get|api docs} for more info
     *
     * @param apiClientID ID of the api client.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.Get = function (apiClientID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/apiclients/".concat(apiClientID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an API client. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/save|api docs} for more info
     *
     * @param apiClientID ID of the api client.
     * @param apiClient Required fields: AccessTokenDuration, AppName
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.Save = function (apiClientID, apiClient, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/apiclients/".concat(apiClientID), __assign(__assign({}, requestOptions), { data: apiClient, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a API client.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/delete|api docs} for more info
     *
     * @param apiClientID ID of the api client.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.Delete = function (apiClientID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/apiclients/".concat(apiClientID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a API client.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/patch|api docs} for more info
     *
     * @param apiClientID ID of the api client.
     * @param apiClient
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.Patch = function (apiClientID, apiClient, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/apiclients/".concat(apiClientID), __assign(__assign({}, requestOptions), { data: apiClient, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of API client assignments.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/list-assignments|api docs} for more info
     *
     * @param listOptions.apiClientID ID of the api client.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.supplierID ID of the supplier.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/apiclients/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a API client assignment.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/save-assignment|api docs} for more info
     *
     * @param apiClientAssignment Required fields: ApiClientID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.SaveAssignment = function (apiClientAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/apiclients/assignments", __assign(__assign({}, requestOptions), { data: apiClientAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a API client buyer assignment.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/delete-buyer-assignment|api docs} for more info
     *
     * @param apiClientID ID of the api client.
     * @param buyerID ID of the buyer.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.DeleteBuyerAssignment = function (apiClientID, buyerID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/ApiClients/Assignments/").concat(apiClientID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a API client supplier assignment.
     * Check out the {@link https://ordercloud.io/api-reference/seller/api-clients/delete-supplier-assignment|api docs} for more info
     *
     * @param apiClientID ID of the api client.
     * @param supplierID ID of the supplier.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApiClients.prototype.DeleteSupplierAssignment = function (apiClientID, supplierID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/suppliers/".concat(supplierID, "/ApiClients/Assignments/").concat(apiClientID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ApiClients.As().List() // lists ApiClients using the impersonated users' token
     */
    ApiClients.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ApiClients;
}());
var ApiClients$1 = new ApiClients();

var Incrementors = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Incrementors() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of incrementors.
     * Check out the {@link https://ordercloud.io/api-reference/seller/incrementors/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Incrementors.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/incrementors", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new incrementor. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/seller/incrementors/create|api docs} for more info
     *
     * @param incrementor Required fields: LastNumber, LeftPaddingCount
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Incrementors.prototype.Create = function (incrementor, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/incrementors", __assign(__assign({}, requestOptions), { data: incrementor, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single incrementor.
     * Check out the {@link https://ordercloud.io/api-reference/seller/incrementors/get|api docs} for more info
     *
     * @param incrementorID ID of the incrementor.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Incrementors.prototype.Get = function (incrementorID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/incrementors/".concat(incrementorID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an incrementor. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/seller/incrementors/save|api docs} for more info
     *
     * @param incrementorID ID of the incrementor.
     * @param incrementor Required fields: LastNumber, LeftPaddingCount
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Incrementors.prototype.Save = function (incrementorID, incrementor, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/incrementors/".concat(incrementorID), __assign(__assign({}, requestOptions), { data: incrementor, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an incrementor.
     * Check out the {@link https://ordercloud.io/api-reference/seller/incrementors/delete|api docs} for more info
     *
     * @param incrementorID ID of the incrementor.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Incrementors.prototype.Delete = function (incrementorID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/incrementors/".concat(incrementorID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an incrementor.
     * Check out the {@link https://ordercloud.io/api-reference/seller/incrementors/patch|api docs} for more info
     *
     * @param incrementorID ID of the incrementor.
     * @param incrementor
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Incrementors.prototype.Patch = function (incrementorID, incrementor, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/incrementors/".concat(incrementorID), __assign(__assign({}, requestOptions), { data: incrementor, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Incrementors.As().List() // lists Incrementors using the impersonated users' token
     */
    Incrementors.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Incrementors;
}());
var Incrementors$1 = new Incrementors();

var Locales = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Locales() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of locales.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/locales", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new locale. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/create|api docs} for more info
     *
     * @param locale Required fields: Currency
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.Create = function (locale, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/locales", __assign(__assign({}, requestOptions), { data: locale, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single locale.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/get|api docs} for more info
     *
     * @param localeID ID of the locale.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.Get = function (localeID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/locales/".concat(localeID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a locale. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/save|api docs} for more info
     *
     * @param localeID ID of the locale.
     * @param locale Required fields: Currency
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.Save = function (localeID, locale, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/locales/".concat(localeID), __assign(__assign({}, requestOptions), { data: locale, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a locale.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/delete|api docs} for more info
     *
     * @param localeID ID of the locale.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.Delete = function (localeID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/locales/".concat(localeID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a locale.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/patch|api docs} for more info
     *
     * @param localeID ID of the locale.
     * @param locale
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.Patch = function (localeID, locale, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/locales/".concat(localeID), __assign(__assign({}, requestOptions), { data: locale, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a locale assignment.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/delete-assignment|api docs} for more info
     *
     * @param localeID ID of the locale.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.DeleteAssignment = function (localeID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/locales/".concat(localeID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of locale assignments.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/list-assignments|api docs} for more info
     *
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.localeID ID of the locale.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the locale assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/locales/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a locale assignment. Do not assign a user multiple groups with different assigned locales. That is considered a misconfiguration, and will yield unexpected results.
     * Check out the {@link https://ordercloud.io/api-reference/seller/locales/save-assignment|api docs} for more info
     *
     * @param localeAssignment Required fields: LocaleID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Locales.prototype.SaveAssignment = function (localeAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/locales/assignments", __assign(__assign({}, requestOptions), { data: localeAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Locales.As().List() // lists Locales using the impersonated users' token
     */
    Locales.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Locales;
}());
var Locales$1 = new Locales();

var Webhooks = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Webhooks() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of webhooks.
     * Check out the {@link https://ordercloud.io/api-reference/seller/webhooks/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Webhooks.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/webhooks", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new webhook. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/seller/webhooks/create|api docs} for more info
     *
     * @param webhook Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Webhooks.prototype.Create = function (webhook, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/webhooks", __assign(__assign({}, requestOptions), { data: webhook, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single webhook.
     * Check out the {@link https://ordercloud.io/api-reference/seller/webhooks/get|api docs} for more info
     *
     * @param webhookID ID of the webhook.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Webhooks.prototype.Get = function (webhookID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/webhooks/".concat(webhookID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a webhook. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/seller/webhooks/save|api docs} for more info
     *
     * @param webhookID ID of the webhook.
     * @param webhook Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Webhooks.prototype.Save = function (webhookID, webhook, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/webhooks/".concat(webhookID), __assign(__assign({}, requestOptions), { data: webhook, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a webhook.
     * Check out the {@link https://ordercloud.io/api-reference/seller/webhooks/delete|api docs} for more info
     *
     * @param webhookID ID of the webhook.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Webhooks.prototype.Delete = function (webhookID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/webhooks/".concat(webhookID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a webhook.
     * Check out the {@link https://ordercloud.io/api-reference/seller/webhooks/patch|api docs} for more info
     *
     * @param webhookID ID of the webhook.
     * @param webhook
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Webhooks.prototype.Patch = function (webhookID, webhook, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/webhooks/".concat(webhookID), __assign(__assign({}, requestOptions), { data: webhook, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Webhooks.As().List() // lists Webhooks using the impersonated users' token
     */
    Webhooks.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Webhooks;
}());
var Webhooks$1 = new Webhooks();

var XpIndices = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function XpIndices() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Put = this.Put.bind(this);
        this.Delete = this.Delete.bind(this);
    }
    /**
     * Get a list of XP indices.
     * Check out the {@link https://ordercloud.io/api-reference/seller/xp-indices/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    XpIndices.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/xpindices", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or Update an XP index.
     * Check out the {@link https://ordercloud.io/api-reference/seller/xp-indices/put|api docs} for more info
     *
     * @param xpIndex
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    XpIndices.prototype.Put = function (xpIndex, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/xpindices", __assign(__assign({}, requestOptions), { data: xpIndex, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a XP index.
     * Check out the {@link https://ordercloud.io/api-reference/seller/xp-indices/delete|api docs} for more info
     *
     * @param thingType Thing type of the xp index. Possible values: Address, Variant, Order, OrderReturn, LineItem, CostCenter, CreditCard, Payment, Spec, SpecOption, UserGroup, Company, Category, PriceSchedule, Shipment, SpendingAccount, User, Promotion, ApprovalRule, SellerApprovalRule, Catalog, ProductFacet, MessageSender, InventoryRecord, ProductCollection, Subscription.
     * @param key Key of the xp index.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    XpIndices.prototype.Delete = function (thingType, key, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/xpindices/".concat(thingType, "/").concat(key), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * XpIndices.As().List() // lists XpIndices using the impersonated users' token
     */
    XpIndices.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return XpIndices;
}());
var XpIndices$1 = new XpIndices();

var Buyers = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Buyers() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ListBuyerSellers = this.ListBuyerSellers.bind(this);
    }
    /**
     * Get a list of buyers.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/buyers/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Buyers.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new buyer. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/buyers/create|api docs} for more info
     *
     * @param buyer Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Buyers.prototype.Create = function (buyer, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers", __assign(__assign({}, requestOptions), { data: buyer, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single buyer.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/buyers/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Buyers.prototype.Get = function (buyerID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a buyer. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/buyers/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param buyer Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Buyers.prototype.Save = function (buyerID, buyer, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID), __assign(__assign({}, requestOptions), { data: buyer, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a buyer.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/buyers/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Buyers.prototype.Delete = function (buyerID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a buyer.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/buyers/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param buyer
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Buyers.prototype.Patch = function (buyerID, buyer, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID), __assign(__assign({}, requestOptions), { data: buyer, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of buyer buyer sellers.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/buyers/list-buyer-sellers|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Buyers.prototype.ListBuyerSellers = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/sellers"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Buyers.As().List() // lists Buyers using the impersonated users' token
     */
    Buyers.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Buyers;
}());
var Buyers$1 = new Buyers();

var Users = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Users() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.GetAccessToken = this.GetAccessToken.bind(this);
        this.Move = this.Move.bind(this);
        this.ListAcrossBuyers = this.ListAcrossBuyers.bind(this);
    }
    /**
     * Get a list of users.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/users"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new user. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/create|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param user Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.Create = function (buyerID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/users"), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single user.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.Get = function (buyerID, userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a user. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userID ID of the user.
     * @param user Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.Save = function (buyerID, userID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a user.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.Delete = function (buyerID, userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a user.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userID ID of the user.
     * @param user
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.Patch = function (buyerID, userID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single user access token.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/get-access-token|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userID ID of the user.
     * @param impersonateTokenRequest Required fields: ClientID, Roles
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.GetAccessToken = function (buyerID, userID, impersonateTokenRequest, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/users/").concat(userID, "/accesstoken"), __assign(__assign({}, requestOptions), { data: impersonateTokenRequest, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Move a user to a different buyer.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/move|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userID ID of the user.
     * @param newBuyerID ID of the new buyer.
     * @param listOptions.orders Orders of the user. Possible values: None, Unsubmitted, All.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.Move = function (buyerID, userID, newBuyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/users/").concat(userID, "/moveto/").concat(newBuyerID), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of user across buyers.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/users/list-across-buyers|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Users.prototype.ListAcrossBuyers = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyerusers", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Users.As().List() // lists Users using the impersonated users' token
     */
    Users.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Users;
}());
var Users$1 = new Users();

var UserGroups = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function UserGroups() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteUserAssignment = this.DeleteUserAssignment.bind(this);
        this.ListUserAssignments = this.ListUserAssignments.bind(this);
        this.SaveUserAssignment = this.SaveUserAssignment.bind(this);
    }
    /**
     * Get a list of user groups.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/usergroups"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new user group. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/create|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userGroup Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.Create = function (buyerID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/usergroups"), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single user group.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.Get = function (buyerID, userGroupID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a user group. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userGroupID ID of the user group.
     * @param userGroup Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.Save = function (buyerID, userGroupID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a user group.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.Delete = function (buyerID, userGroupID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a user group.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userGroupID ID of the user group.
     * @param userGroup
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.Patch = function (buyerID, userGroupID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a user group user assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/delete-user-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userGroupID ID of the user group.
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.DeleteUserAssignment = function (buyerID, userGroupID, userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/usergroups/").concat(userGroupID, "/assignments/").concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of user group user assignments.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/list-user-assignments|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.userID ID of the user.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.ListUserAssignments = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/usergroups/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a user group user assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/user-groups/save-user-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param userGroupAssignment Required fields: UserGroupID, UserID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserGroups.prototype.SaveUserAssignment = function (buyerID, userGroupAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/usergroups/assignments"), __assign(__assign({}, requestOptions), { data: userGroupAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * UserGroups.As().List() // lists UserGroups using the impersonated users' token
     */
    UserGroups.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return UserGroups;
}());
var UserGroups$1 = new UserGroups();

var Addresses = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Addresses() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of addresses.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/addresses"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new address. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/create|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.Create = function (buyerID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/addresses"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single address.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.Get = function (buyerID, addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an address. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param addressID ID of the address.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.Save = function (buyerID, addressID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an address.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.Delete = function (buyerID, addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an address.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param addressID ID of the address.
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.Patch = function (buyerID, addressID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an address assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/delete-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param addressID ID of the address.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.DeleteAssignment = function (buyerID, addressID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/addresses/").concat(addressID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of address assignments.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/list-assignments|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.addressID ID of the address.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the address assignment. Possible values: User, Group, Company.
     * @param listOptions.isShipping Is shipping of the address assignment.
     * @param listOptions.isBilling Is billing of the address assignment.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.ListAssignments = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/addresses/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an address assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/addresses/save-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param addressAssignment Required fields: AddressID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Addresses.prototype.SaveAssignment = function (buyerID, addressAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/addresses/assignments"), __assign(__assign({}, requestOptions), { data: addressAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Addresses.As().List() // lists Addresses using the impersonated users' token
     */
    Addresses.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Addresses;
}());
var Addresses$1 = new Addresses();

var CostCenters = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function CostCenters() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of cost centers.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/costcenters"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new cost center. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/create|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param costCenter Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.Create = function (buyerID, costCenter, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/costcenters"), __assign(__assign({}, requestOptions), { data: costCenter, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single cost center.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param costCenterID ID of the cost center.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.Get = function (buyerID, costCenterID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/costcenters/").concat(costCenterID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a cost center. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param costCenterID ID of the cost center.
     * @param costCenter Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.Save = function (buyerID, costCenterID, costCenter, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID, "/costcenters/").concat(costCenterID), __assign(__assign({}, requestOptions), { data: costCenter, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cost center.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param costCenterID ID of the cost center.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.Delete = function (buyerID, costCenterID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/costcenters/").concat(costCenterID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a cost center.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param costCenterID ID of the cost center.
     * @param costCenter
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.Patch = function (buyerID, costCenterID, costCenter, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID, "/costcenters/").concat(costCenterID), __assign(__assign({}, requestOptions), { data: costCenter, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cost center assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/delete-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param costCenterID ID of the cost center.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.DeleteAssignment = function (buyerID, costCenterID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/costcenters/").concat(costCenterID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of cost center assignments.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/list-assignments|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.costCenterID ID of the cost center.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the cost center assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.ListAssignments = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/costcenters/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a cost center assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/cost-centers/save-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param costCenterAssignment Required fields: CostCenterID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CostCenters.prototype.SaveAssignment = function (buyerID, costCenterAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/costcenters/assignments"), __assign(__assign({}, requestOptions), { data: costCenterAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * CostCenters.As().List() // lists CostCenters using the impersonated users' token
     */
    CostCenters.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return CostCenters;
}());
var CostCenters$1 = new CostCenters();

var CreditCards = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function CreditCards() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of credit cards.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/creditcards"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new credit card. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/create|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param creditCard
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.Create = function (buyerID, creditCard, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/creditcards"), __assign(__assign({}, requestOptions), { data: creditCard, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single credit card.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param creditCardID ID of the credit card.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.Get = function (buyerID, creditCardID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/creditcards/").concat(creditCardID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a credit card. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param creditCardID ID of the credit card.
     * @param creditCard
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.Save = function (buyerID, creditCardID, creditCard, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID, "/creditcards/").concat(creditCardID), __assign(__assign({}, requestOptions), { data: creditCard, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a credit card.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param creditCardID ID of the credit card.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.Delete = function (buyerID, creditCardID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/creditcards/").concat(creditCardID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a credit card.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param creditCardID ID of the credit card.
     * @param creditCard
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.Patch = function (buyerID, creditCardID, creditCard, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID, "/creditcards/").concat(creditCardID), __assign(__assign({}, requestOptions), { data: creditCard, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a credit card assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/delete-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param creditCardID ID of the credit card.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.DeleteAssignment = function (buyerID, creditCardID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/creditcards/").concat(creditCardID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of credit card assignments.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/list-assignments|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.creditCardID ID of the credit card.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the credit card assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.ListAssignments = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/creditcards/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a credit card assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/credit-cards/save-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param creditCardAssignment Required fields: CreditCardID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    CreditCards.prototype.SaveAssignment = function (buyerID, creditCardAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/creditcards/assignments"), __assign(__assign({}, requestOptions), { data: creditCardAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * CreditCards.As().List() // lists CreditCards using the impersonated users' token
     */
    CreditCards.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return CreditCards;
}());
var CreditCards$1 = new CreditCards();

var SpendingAccounts = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SpendingAccounts() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of spending accounts.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/spendingaccounts"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new spending account. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/create|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param spendingAccount Required fields: Name, Balance
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.Create = function (buyerID, spendingAccount, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/spendingaccounts"), __assign(__assign({}, requestOptions), { data: spendingAccount, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single spending account.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param spendingAccountID ID of the spending account.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.Get = function (buyerID, spendingAccountID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/spendingaccounts/").concat(spendingAccountID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a spending account. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param spendingAccountID ID of the spending account.
     * @param spendingAccount Required fields: Name, Balance
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.Save = function (buyerID, spendingAccountID, spendingAccount, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID, "/spendingaccounts/").concat(spendingAccountID), __assign(__assign({}, requestOptions), { data: spendingAccount, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a spending account.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param spendingAccountID ID of the spending account.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.Delete = function (buyerID, spendingAccountID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/spendingaccounts/").concat(spendingAccountID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a spending account.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param spendingAccountID ID of the spending account.
     * @param spendingAccount
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.Patch = function (buyerID, spendingAccountID, spendingAccount, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID, "/spendingaccounts/").concat(spendingAccountID), __assign(__assign({}, requestOptions), { data: spendingAccount, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a spending account assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/delete-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param spendingAccountID ID of the spending account.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.DeleteAssignment = function (buyerID, spendingAccountID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/spendingaccounts/").concat(spendingAccountID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of spending account assignments.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/list-assignments|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.spendingAccountID ID of the spending account.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the spending account assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.ListAssignments = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/spendingaccounts/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a spending account assignment.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/spending-accounts/save-assignment|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param spendingAccountAssignment Required fields: SpendingAccountID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SpendingAccounts.prototype.SaveAssignment = function (buyerID, spendingAccountAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/spendingaccounts/assignments"), __assign(__assign({}, requestOptions), { data: spendingAccountAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SpendingAccounts.As().List() // lists SpendingAccounts using the impersonated users' token
     */
    SpendingAccounts.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SpendingAccounts;
}());
var SpendingAccounts$1 = new SpendingAccounts();

var ApprovalRules = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ApprovalRules() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of approval rules.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/approval-rules/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApprovalRules.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/approvalrules"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new approval rule. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/approval-rules/create|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param approvalRule Required fields: ApprovingGroupID, RuleExpression
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApprovalRules.prototype.Create = function (buyerID, approvalRule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/buyers/".concat(buyerID, "/approvalrules"), __assign(__assign({}, requestOptions), { data: approvalRule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single approval rule.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/approval-rules/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param approvalRuleID ID of the approval rule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApprovalRules.prototype.Get = function (buyerID, approvalRuleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/approvalrules/").concat(approvalRuleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an approval rule. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/approval-rules/save|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param approvalRuleID ID of the approval rule.
     * @param approvalRule Required fields: ApprovingGroupID, RuleExpression
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApprovalRules.prototype.Save = function (buyerID, approvalRuleID, approvalRule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/buyers/".concat(buyerID, "/approvalrules/").concat(approvalRuleID), __assign(__assign({}, requestOptions), { data: approvalRule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an approval rule.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/approval-rules/delete|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param approvalRuleID ID of the approval rule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApprovalRules.prototype.Delete = function (buyerID, approvalRuleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/buyers/".concat(buyerID, "/approvalrules/").concat(approvalRuleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an approval rule.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/approval-rules/patch|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param approvalRuleID ID of the approval rule.
     * @param approvalRule
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ApprovalRules.prototype.Patch = function (buyerID, approvalRuleID, approvalRule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/buyers/".concat(buyerID, "/approvalrules/").concat(approvalRuleID), __assign(__assign({}, requestOptions), { data: approvalRule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ApprovalRules.As().List() // lists ApprovalRules using the impersonated users' token
     */
    ApprovalRules.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ApprovalRules;
}());
var ApprovalRules$1 = new ApprovalRules();

var ProductCollections = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ProductCollections() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Get = this.Get.bind(this);
        this.ListEntries = this.ListEntries.bind(this);
    }
    /**
     * Get a list of product collections.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/product-collections/list|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductCollections.prototype.List = function (buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/productcollections"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single product collection.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/product-collections/get|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param productCollectionID ID of the product collection.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductCollections.prototype.Get = function (buyerID, productCollectionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/productcollections/").concat(productCollectionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product collection entries.
     * Check out the {@link https://ordercloud.io/api-reference/buyers/product-collections/list-entries|api docs} for more info
     *
     * @param buyerID ID of the buyer.
     * @param productCollectionID ID of the product collection.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductCollections.prototype.ListEntries = function (buyerID, productCollectionID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/buyers/".concat(buyerID, "/productcollections/").concat(productCollectionID, "/products"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ProductCollections.As().List() // lists ProductCollections using the impersonated users' token
     */
    ProductCollections.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ProductCollections;
}());
var ProductCollections$1 = new ProductCollections();

var Suppliers = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Suppliers() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ListBuyers = this.ListBuyers.bind(this);
        this.SaveBuyer = this.SaveBuyer.bind(this);
        this.DeleteBuyer = this.DeleteBuyer.bind(this);
    }
    /**
     * Get a list of suppliers.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new supplier. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/create|api docs} for more info
     *
     * @param supplier Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.Create = function (supplier, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/suppliers", __assign(__assign({}, requestOptions), { data: supplier, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single supplier.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/get|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.Get = function (supplierID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a supplier. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/save|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param supplier Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.Save = function (supplierID, supplier, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/suppliers/".concat(supplierID), __assign(__assign({}, requestOptions), { data: supplier, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a supplier.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/delete|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.Delete = function (supplierID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/suppliers/".concat(supplierID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a supplier.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/patch|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param supplier
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.Patch = function (supplierID, supplier, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/suppliers/".concat(supplierID), __assign(__assign({}, requestOptions), { data: supplier, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of supplier buyers.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/list-buyers|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.ListBuyers = function (supplierID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/buyers"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a supplier buyer.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/save-buyer|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param buyerID ID of the buyer.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.SaveBuyer = function (supplierID, buyerID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/suppliers/".concat(supplierID, "/buyers/").concat(buyerID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a supplier buyer.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/suppliers/delete-buyer|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param buyerID ID of the buyer.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Suppliers.prototype.DeleteBuyer = function (supplierID, buyerID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/suppliers/".concat(supplierID, "/buyers/").concat(buyerID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Suppliers.As().List() // lists Suppliers using the impersonated users' token
     */
    Suppliers.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Suppliers;
}());
var Suppliers$1 = new Suppliers();

var SupplierUsers = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SupplierUsers() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of supplier users.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-users/list|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUsers.prototype.List = function (supplierID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/users"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new supplier user. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-users/create|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param user Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUsers.prototype.Create = function (supplierID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/suppliers/".concat(supplierID, "/users"), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single supplier user.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-users/get|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUsers.prototype.Get = function (supplierID, userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a supplier user. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-users/save|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userID ID of the user.
     * @param user Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUsers.prototype.Save = function (supplierID, userID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/suppliers/".concat(supplierID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a supplier user.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-users/delete|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUsers.prototype.Delete = function (supplierID, userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/suppliers/".concat(supplierID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a supplier user.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-users/patch|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userID ID of the user.
     * @param user
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUsers.prototype.Patch = function (supplierID, userID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/suppliers/".concat(supplierID, "/users/").concat(userID), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SupplierUsers.As().List() // lists SupplierUsers using the impersonated users' token
     */
    SupplierUsers.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SupplierUsers;
}());
var SupplierUsers$1 = new SupplierUsers();

var SupplierUserGroups = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SupplierUserGroups() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteUserAssignment = this.DeleteUserAssignment.bind(this);
        this.ListUserAssignments = this.ListUserAssignments.bind(this);
        this.SaveUserAssignment = this.SaveUserAssignment.bind(this);
    }
    /**
     * Get a list of supplier user groups.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/list|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.List = function (supplierID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/usergroups"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new supplier user group. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/create|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userGroup Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.Create = function (supplierID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/suppliers/".concat(supplierID, "/usergroups"), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single supplier user group.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/get|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.Get = function (supplierID, userGroupID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a supplier user group. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/save|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userGroupID ID of the user group.
     * @param userGroup Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.Save = function (supplierID, userGroupID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/suppliers/".concat(supplierID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a supplier user group.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/delete|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.Delete = function (supplierID, userGroupID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/suppliers/".concat(supplierID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a supplier user group.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/patch|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userGroupID ID of the user group.
     * @param userGroup
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.Patch = function (supplierID, userGroupID, userGroup, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/suppliers/".concat(supplierID, "/usergroups/").concat(userGroupID), __assign(__assign({}, requestOptions), { data: userGroup, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a supplier user group user assignment.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/delete-user-assignment|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userGroupID ID of the user group.
     * @param userID ID of the user.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.DeleteUserAssignment = function (supplierID, userGroupID, userID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/suppliers/".concat(supplierID, "/usergroups/").concat(userGroupID, "/assignments/").concat(userID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of supplier user group user assignments.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/list-user-assignments|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.userID ID of the user.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.ListUserAssignments = function (supplierID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/usergroups/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a supplier user group user assignment.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-user-groups/save-user-assignment|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param userGroupAssignment Required fields: UserGroupID, UserID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierUserGroups.prototype.SaveUserAssignment = function (supplierID, userGroupAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/suppliers/".concat(supplierID, "/usergroups/assignments"), __assign(__assign({}, requestOptions), { data: userGroupAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SupplierUserGroups.As().List() // lists SupplierUserGroups using the impersonated users' token
     */
    SupplierUserGroups.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SupplierUserGroups;
}());
var SupplierUserGroups$1 = new SupplierUserGroups();

var SupplierAddresses = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SupplierAddresses() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of supplier addresses.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-addresses/list|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierAddresses.prototype.List = function (supplierID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/addresses"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new supplier address. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-addresses/create|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierAddresses.prototype.Create = function (supplierID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/suppliers/".concat(supplierID, "/addresses"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single supplier address.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-addresses/get|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierAddresses.prototype.Get = function (supplierID, addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/suppliers/".concat(supplierID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a supplier address. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-addresses/save|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param addressID ID of the address.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierAddresses.prototype.Save = function (supplierID, addressID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/suppliers/".concat(supplierID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a supplier address.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-addresses/delete|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierAddresses.prototype.Delete = function (supplierID, addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/suppliers/".concat(supplierID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a supplier address.
     * Check out the {@link https://ordercloud.io/api-reference/suppliers/supplier-addresses/patch|api docs} for more info
     *
     * @param supplierID ID of the supplier.
     * @param addressID ID of the address.
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SupplierAddresses.prototype.Patch = function (supplierID, addressID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/suppliers/".concat(supplierID, "/addresses/").concat(addressID), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SupplierAddresses.As().List() // lists SupplierAddresses using the impersonated users' token
     */
    SupplierAddresses.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SupplierAddresses;
}());
var SupplierAddresses$1 = new SupplierAddresses();

var Catalogs = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Catalogs() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.DeleteBundleAssignment = this.DeleteBundleAssignment.bind(this);
        this.DeleteProductAssignment = this.DeleteProductAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
        this.ListBundleAssignments = this.ListBundleAssignments.bind(this);
        this.SaveBundleAssignment = this.SaveBundleAssignment.bind(this);
        this.ListProductAssignments = this.ListProductAssignments.bind(this);
        this.SaveProductAssignment = this.SaveProductAssignment.bind(this);
    }
    /**
     * Get a list of catalogs.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new catalog. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/create|api docs} for more info
     *
     * @param catalog Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.Create = function (catalog, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs", __assign(__assign({}, requestOptions), { data: catalog, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single catalog.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/get|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.Get = function (catalogID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/".concat(catalogID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a catalog. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/save|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param catalog Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.Save = function (catalogID, catalog, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/catalogs/".concat(catalogID), __assign(__assign({}, requestOptions), { data: catalog, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a catalog.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/delete|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.Delete = function (catalogID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a catalog.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/patch|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param catalog
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.Patch = function (catalogID, catalog, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/catalogs/".concat(catalogID), __assign(__assign({}, requestOptions), { data: catalog, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a catalog assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/delete-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param listOptions.buyerID ID of the buyer.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.DeleteAssignment = function (catalogID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a catalog bundle assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/delete-bundle-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param bundleID ID of the bundle.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.DeleteBundleAssignment = function (catalogID, bundleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID, "/bundleassignments/").concat(bundleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a catalog product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/delete-product-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.DeleteProductAssignment = function (catalogID, productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID, "/productassignments/").concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of catalog assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/list-assignments|api docs} for more info
     *
     * @param listOptions.catalogID ID of the catalog.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a catalog assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/save-assignment|api docs} for more info
     *
     * @param catalogAssignment Required fields: CatalogID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.SaveAssignment = function (catalogAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs/assignments", __assign(__assign({}, requestOptions), { data: catalogAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of catalog bundle assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/list-bundle-assignments|api docs} for more info
     *
     * @param listOptions.catalogID ID of the catalog.
     * @param listOptions.bundleID ID of the bundle.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.ListBundleAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/bundleassignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a catalog bundle assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/save-bundle-assignment|api docs} for more info
     *
     * @param bundleCatalogAssignment Required fields: CatalogID, BundleID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.SaveBundleAssignment = function (bundleCatalogAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs/bundleassignments", __assign(__assign({}, requestOptions), { data: bundleCatalogAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of catalog product assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/list-product-assignments|api docs} for more info
     *
     * @param listOptions.catalogID ID of the catalog.
     * @param listOptions.productID ID of the product.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.ListProductAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/productassignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a catalog product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/catalogs/save-product-assignment|api docs} for more info
     *
     * @param productCatalogAssignment Required fields: CatalogID, ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Catalogs.prototype.SaveProductAssignment = function (productCatalogAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs/productassignments", __assign(__assign({}, requestOptions), { data: productCatalogAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Catalogs.As().List() // lists Catalogs using the impersonated users' token
     */
    Catalogs.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Catalogs;
}());
var Catalogs$1 = new Catalogs();

var Categories = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Categories() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.DeleteBundleAssignment = this.DeleteBundleAssignment.bind(this);
        this.DeleteProductAssignment = this.DeleteProductAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
        this.ListBundleAssignments = this.ListBundleAssignments.bind(this);
        this.SaveBundleAssignment = this.SaveBundleAssignment.bind(this);
        this.ListProductAssignments = this.ListProductAssignments.bind(this);
        this.SaveProductAssignment = this.SaveProductAssignment.bind(this);
    }
    /**
     * Get a list of categories.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/list|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param listOptions.depth Depth of the category.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.List = function (catalogID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/".concat(catalogID, "/categories"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new category. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.<br/></br>Setting adjustListOrders to true will increase ListOrder for all categories with the same or higher ListOrder.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/create|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param listOptions.adjustListOrders Adjust list orders of the category.
     * @param category Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.Create = function (catalogID, category, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs/".concat(catalogID, "/categories"), __assign(__assign({}, requestOptions), { data: category, impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single category.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/get|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryID ID of the category.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.Get = function (catalogID, categoryID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/".concat(catalogID, "/categories/").concat(categoryID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a category. If an object with the same ID already exists, it will be overwritten.<br/></br>Setting adjustListOrders to true will increase ListOrder for all categories with the same or higher ListOrder.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/save|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryID ID of the category.
     * @param listOptions.adjustListOrders Adjust list orders of the category.
     * @param category Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.Save = function (catalogID, categoryID, category, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/catalogs/".concat(catalogID, "/categories/").concat(categoryID), __assign(__assign({}, requestOptions), { data: category, impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a category. Deleting a parent category will also delete all of that category's children.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/delete|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryID ID of the category.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.Delete = function (catalogID, categoryID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID, "/categories/").concat(categoryID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a category. Setting adjustListOrders to true will increase ListOrder for all categories with the same or higher ListOrder.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/patch|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryID ID of the category.
     * @param listOptions.adjustListOrders Adjust list orders of the partial 1.
     * @param category
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.Patch = function (catalogID, categoryID, category, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/catalogs/".concat(catalogID, "/categories/").concat(categoryID), __assign(__assign({}, requestOptions), { data: category, impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a category assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/delete-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryID ID of the category.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.DeleteAssignment = function (catalogID, categoryID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID, "/categories/").concat(categoryID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a category bundle assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/delete-bundle-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryID ID of the category.
     * @param bundleID ID of the bundle.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.DeleteBundleAssignment = function (catalogID, categoryID, bundleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID, "/categories/").concat(categoryID, "/bundleassignments/").concat(bundleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a category product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/delete-product-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryID ID of the category.
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.DeleteProductAssignment = function (catalogID, categoryID, productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/catalogs/".concat(catalogID, "/categories/").concat(categoryID, "/productassignments/").concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of category assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/list-assignments|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param listOptions.categoryID ID of the category.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the category assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.ListAssignments = function (catalogID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/".concat(catalogID, "/categories/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a category assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/save-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryAssignment Required fields: CategoryID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.SaveAssignment = function (catalogID, categoryAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs/".concat(catalogID, "/categories/assignments"), __assign(__assign({}, requestOptions), { data: categoryAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of category bundle assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/list-bundle-assignments|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param listOptions.categoryID ID of the category.
     * @param listOptions.bundleID ID of the bundle.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.ListBundleAssignments = function (catalogID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/".concat(catalogID, "/categories/bundleassignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a category bundle assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/save-bundle-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryBundleAssignment Required fields: CategoryID, BundleID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.SaveBundleAssignment = function (catalogID, categoryBundleAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs/".concat(catalogID, "/categories/bundleassignments"), __assign(__assign({}, requestOptions), { data: categoryBundleAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of category product assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/list-product-assignments|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param listOptions.categoryID ID of the category.
     * @param listOptions.productID ID of the product.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.ListProductAssignments = function (catalogID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/catalogs/".concat(catalogID, "/categories/productassignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a category product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/categories/save-product-assignment|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param categoryProductAssignment Required fields: CategoryID, ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Categories.prototype.SaveProductAssignment = function (catalogID, categoryProductAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/catalogs/".concat(catalogID, "/categories/productassignments"), __assign(__assign({}, requestOptions), { data: categoryProductAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Categories.As().List() // lists Categories using the impersonated users' token
     */
    Categories.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Categories;
}());
var Categories$1 = new Categories();

var Products = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Products() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListSpecs = this.ListSpecs.bind(this);
        this.ListSuppliers = this.ListSuppliers.bind(this);
        this.SaveSupplier = this.SaveSupplier.bind(this);
        this.RemoveSupplier = this.RemoveSupplier.bind(this);
        this.ListVariants = this.ListVariants.bind(this);
        this.GetVariant = this.GetVariant.bind(this);
        this.SaveVariant = this.SaveVariant.bind(this);
        this.PatchVariant = this.PatchVariant.bind(this);
        this.GenerateVariants = this.GenerateVariants.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of products.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/list|api docs} for more info
     *
     * @param listOptions.catalogID ID of the catalog.
     * @param listOptions.categoryID ID of the category.
     * @param listOptions.supplierID ID of the supplier.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new product. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/create|api docs} for more info
     *
     * @param product Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.Create = function (product, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/products", __assign(__assign({}, requestOptions), { data: product, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single product.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/get|api docs} for more info
     *
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.Get = function (productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a product. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/save|api docs} for more info
     *
     * @param productID ID of the product.
     * @param product Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.Save = function (productID, product, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/products/".concat(productID), __assign(__assign({}, requestOptions), { data: product, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a product.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/delete|api docs} for more info
     *
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.Delete = function (productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/products/".concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a product.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/patch|api docs} for more info
     *
     * @param productID ID of the product.
     * @param product
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.Patch = function (productID, product, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/products/".concat(productID), __assign(__assign({}, requestOptions), { data: product, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/delete-assignment|api docs} for more info
     *
     * @param productID ID of the product.
     * @param buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.sellerID ID of the seller.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.DeleteAssignment = function (productID, buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/products/".concat(productID, "/assignments/").concat(buyerID), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product specs.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/list-specs|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.ListSpecs = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/specs"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product suppliers.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/list-suppliers|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.ListSuppliers = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/suppliers"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a product supplier.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/save-supplier|api docs} for more info
     *
     * @param productID ID of the product.
     * @param supplierID ID of the supplier.
     * @param listOptions.defaultPriceScheduleID ID of the default price schedule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.SaveSupplier = function (productID, supplierID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/products/".concat(productID, "/suppliers/").concat(supplierID), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove a product supplier.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/remove-supplier|api docs} for more info
     *
     * @param productID ID of the product.
     * @param supplierID ID of the supplier.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.RemoveSupplier = function (productID, supplierID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/products/".concat(productID, "/suppliers/").concat(supplierID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product variants.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/list-variants|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.ListVariants = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/variants"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single product variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/get-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.GetVariant = function (productID, variantID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/variants/").concat(variantID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a product variant. Update a product variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/save-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param variant
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.SaveVariant = function (productID, variantID, variant, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/products/".concat(productID, "/variants/").concat(variantID), __assign(__assign({}, requestOptions), { data: variant, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a product variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/patch-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param variant
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.PatchVariant = function (productID, variantID, variant, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/products/".concat(productID, "/variants/").concat(variantID), __assign(__assign({}, requestOptions), { data: variant, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Generate a variants.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/generate-variants|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.overwriteExisting Overwrite existing of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.GenerateVariants = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/products/".concat(productID, "/variants/generate"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/list-assignments|api docs} for more info
     *
     * @param listOptions.productID ID of the product.
     * @param listOptions.priceScheduleID ID of the price schedule.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the product assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/products/save-assignment|api docs} for more info
     *
     * @param productAssignment Required fields: ProductID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Products.prototype.SaveAssignment = function (productAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/products/assignments", __assign(__assign({}, requestOptions), { data: productAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Products.As().List() // lists Products using the impersonated users' token
     */
    Products.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Products;
}());
var Products$1 = new Products();

var PriceSchedules = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function PriceSchedules() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.SavePriceBreak = this.SavePriceBreak.bind(this);
        this.DeletePriceBreak = this.DeletePriceBreak.bind(this);
    }
    /**
     * Get a list of price schedules.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/priceschedules", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new price schedule. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/create|api docs} for more info
     *
     * @param priceSchedule Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.Create = function (priceSchedule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/priceschedules", __assign(__assign({}, requestOptions), { data: priceSchedule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single price schedule.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/get|api docs} for more info
     *
     * @param priceScheduleID ID of the price schedule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.Get = function (priceScheduleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/priceschedules/".concat(priceScheduleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a price schedule. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/save|api docs} for more info
     *
     * @param priceScheduleID ID of the price schedule.
     * @param priceSchedule Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.Save = function (priceScheduleID, priceSchedule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/priceschedules/".concat(priceScheduleID), __assign(__assign({}, requestOptions), { data: priceSchedule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a price schedule.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/delete|api docs} for more info
     *
     * @param priceScheduleID ID of the price schedule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.Delete = function (priceScheduleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/priceschedules/".concat(priceScheduleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a price schedule.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/patch|api docs} for more info
     *
     * @param priceScheduleID ID of the price schedule.
     * @param priceSchedule
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.Patch = function (priceScheduleID, priceSchedule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/priceschedules/".concat(priceScheduleID), __assign(__assign({}, requestOptions), { data: priceSchedule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a price schedule price break.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/save-price-break|api docs} for more info
     *
     * @param priceScheduleID ID of the price schedule.
     * @param priceBreak Required fields: Quantity, Price
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.SavePriceBreak = function (priceScheduleID, priceBreak, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/priceschedules/".concat(priceScheduleID, "/PriceBreaks"), __assign(__assign({}, requestOptions), { data: priceBreak, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a price schedule price break.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/price-schedules/delete-price-break|api docs} for more info
     *
     * @param priceScheduleID ID of the price schedule.
     * @param listOptions.quantity Quantity of the price schedule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    PriceSchedules.prototype.DeletePriceBreak = function (priceScheduleID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/priceschedules/".concat(priceScheduleID, "/PriceBreaks"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * PriceSchedules.As().List() // lists PriceSchedules using the impersonated users' token
     */
    PriceSchedules.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return PriceSchedules;
}());
var PriceSchedules$1 = new PriceSchedules();

var Specs = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Specs() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ListOptions = this.ListOptions.bind(this);
        this.CreateOption = this.CreateOption.bind(this);
        this.GetOption = this.GetOption.bind(this);
        this.SaveOption = this.SaveOption.bind(this);
        this.DeleteOption = this.DeleteOption.bind(this);
        this.PatchOption = this.PatchOption.bind(this);
        this.DeleteProductAssignment = this.DeleteProductAssignment.bind(this);
        this.ListProductAssignments = this.ListProductAssignments.bind(this);
        this.SaveProductAssignment = this.SaveProductAssignment.bind(this);
    }
    /**
     * Get a list of specs.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/specs", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new spec. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/create|api docs} for more info
     *
     * @param spec Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.Create = function (spec, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/specs", __assign(__assign({}, requestOptions), { data: spec, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single spec.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/get|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.Get = function (specID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/specs/".concat(specID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a spec. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/save|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param spec Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.Save = function (specID, spec, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/specs/".concat(specID), __assign(__assign({}, requestOptions), { data: spec, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a spec.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/delete|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.Delete = function (specID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/specs/".concat(specID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a spec.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/patch|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param spec
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.Patch = function (specID, spec, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/specs/".concat(specID), __assign(__assign({}, requestOptions), { data: spec, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of spec options.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/list-options|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.ListOptions = function (specID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/specs/".concat(specID, "/options"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new spec option. A Spec can have multiple Options-- for example, if the spec is called 'Color', the options might be 'Blue', 'Red', and 'Green'.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/create-option|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param specOption Required fields: Value
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.CreateOption = function (specID, specOption, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/specs/".concat(specID, "/options"), __assign(__assign({}, requestOptions), { data: specOption, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single spec option.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/get-option|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param optionID ID of the option.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.GetOption = function (specID, optionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/specs/".concat(specID, "/options/").concat(optionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a spec option.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/save-option|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param optionID ID of the option.
     * @param specOption Required fields: Value
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.SaveOption = function (specID, optionID, specOption, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/specs/".concat(specID, "/options/").concat(optionID), __assign(__assign({}, requestOptions), { data: specOption, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a spec option.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/delete-option|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param optionID ID of the option.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.DeleteOption = function (specID, optionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/specs/".concat(specID, "/options/").concat(optionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a spec option.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/patch-option|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param optionID ID of the option.
     * @param specOption
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.PatchOption = function (specID, optionID, specOption, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/specs/".concat(specID, "/options/").concat(optionID), __assign(__assign({}, requestOptions), { data: specOption, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a spec product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/delete-product-assignment|api docs} for more info
     *
     * @param specID ID of the spec.
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.DeleteProductAssignment = function (specID, productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/specs/".concat(specID, "/productassignments/").concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of spec product assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/list-product-assignments|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.ListProductAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/specs/productassignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a spec product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/specs/save-product-assignment|api docs} for more info
     *
     * @param specProductAssignment Required fields: SpecID, ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Specs.prototype.SaveProductAssignment = function (specProductAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/specs/productassignments", __assign(__assign({}, requestOptions), { data: specProductAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Specs.As().List() // lists Specs using the impersonated users' token
     */
    Specs.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Specs;
}());
var Specs$1 = new Specs();

var ProductFacets = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ProductFacets() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of product facets.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/product-facets/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductFacets.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/productfacets", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new product facet. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/product-facets/create|api docs} for more info
     *
     * @param productFacet Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductFacets.prototype.Create = function (productFacet, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/productfacets", __assign(__assign({}, requestOptions), { data: productFacet, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single product facet.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/product-facets/get|api docs} for more info
     *
     * @param productFacetID ID of the product facet.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductFacets.prototype.Get = function (productFacetID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/productfacets/".concat(productFacetID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a product facet. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/product-facets/save|api docs} for more info
     *
     * @param productFacetID ID of the product facet.
     * @param productFacet Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductFacets.prototype.Save = function (productFacetID, productFacet, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/productfacets/".concat(productFacetID), __assign(__assign({}, requestOptions), { data: productFacet, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a product facet.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/product-facets/delete|api docs} for more info
     *
     * @param productFacetID ID of the product facet.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductFacets.prototype.Delete = function (productFacetID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/productfacets/".concat(productFacetID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a product facet.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/product-facets/patch|api docs} for more info
     *
     * @param productFacetID ID of the product facet.
     * @param productFacet
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductFacets.prototype.Patch = function (productFacetID, productFacet, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/productfacets/".concat(productFacetID), __assign(__assign({}, requestOptions), { data: productFacet, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ProductFacets.As().List() // lists ProductFacets using the impersonated users' token
     */
    ProductFacets.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ProductFacets;
}());
var ProductFacets$1 = new ProductFacets();

var InventoryRecords = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function InventoryRecords() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
        this.ListVariant = this.ListVariant.bind(this);
        this.CreateVariant = this.CreateVariant.bind(this);
        this.GetVariant = this.GetVariant.bind(this);
        this.SaveVariant = this.SaveVariant.bind(this);
        this.DeleteVariant = this.DeleteVariant.bind(this);
        this.PatchVariant = this.PatchVariant.bind(this);
        this.DeleteVariantAssignment = this.DeleteVariantAssignment.bind(this);
        this.ListVariantAssignments = this.ListVariantAssignments.bind(this);
        this.SaveVariantAssignment = this.SaveVariantAssignment.bind(this);
    }
    /**
     * Get a list of inventory records.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/list|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.List = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/inventoryrecords"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new inventory record. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/create|api docs} for more info
     *
     * @param productID ID of the product.
     * @param inventoryRecord Required fields: AddressID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.Create = function (productID, inventoryRecord, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/products/".concat(productID, "/inventoryrecords"), __assign(__assign({}, requestOptions), { data: inventoryRecord, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single inventory record.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/get|api docs} for more info
     *
     * @param productID ID of the product.
     * @param inventoryRecordID ID of the inventory record.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.Get = function (productID, inventoryRecordID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an inventory record. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/save|api docs} for more info
     *
     * @param productID ID of the product.
     * @param inventoryRecordID ID of the inventory record.
     * @param inventoryRecord Required fields: AddressID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.Save = function (productID, inventoryRecordID, inventoryRecord, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/products/".concat(productID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { data: inventoryRecord, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an inventory record.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/delete|api docs} for more info
     *
     * @param productID ID of the product.
     * @param inventoryRecordID ID of the inventory record.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.Delete = function (productID, inventoryRecordID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/products/".concat(productID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an inventory record.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/patch|api docs} for more info
     *
     * @param productID ID of the product.
     * @param inventoryRecordID ID of the inventory record.
     * @param inventoryRecord
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.Patch = function (productID, inventoryRecordID, inventoryRecord, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/products/".concat(productID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { data: inventoryRecord, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an inventory record assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/delete-assignment|api docs} for more info
     *
     * @param productID ID of the product.
     * @param inventoryRecordID ID of the inventory record.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.DeleteAssignment = function (productID, inventoryRecordID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/products/".concat(productID, "/inventoryrecords/").concat(inventoryRecordID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of inventory record assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/list-assignments|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.inventoryRecordID ID of the inventory record.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the inventory record assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.ListAssignments = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/inventoryrecords/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an inventory record assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/save-assignment|api docs} for more info
     *
     * @param productID ID of the product.
     * @param inventoryRecordAssignment Required fields: InventoryRecordID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.SaveAssignment = function (productID, inventoryRecordAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/products/".concat(productID, "/inventoryrecords/assignments"), __assign(__assign({}, requestOptions), { data: inventoryRecordAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of inventory record variants.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/list-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.ListVariant = function (productID, variantID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new inventory record variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/create-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param inventoryRecord Required fields: AddressID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.CreateVariant = function (productID, variantID, inventoryRecord, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords"), __assign(__assign({}, requestOptions), { data: inventoryRecord, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single inventory record variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/get-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param inventoryRecordID ID of the inventory record.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.GetVariant = function (productID, variantID, inventoryRecordID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an inventory record variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/save-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param inventoryRecordID ID of the inventory record.
     * @param inventoryRecord Required fields: AddressID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.SaveVariant = function (productID, variantID, inventoryRecordID, inventoryRecord, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { data: inventoryRecord, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an inventory record variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/delete-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param inventoryRecordID ID of the inventory record.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.DeleteVariant = function (productID, variantID, inventoryRecordID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an inventory record variant.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/patch-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param inventoryRecordID ID of the inventory record.
     * @param inventoryRecord
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.PatchVariant = function (productID, variantID, inventoryRecordID, inventoryRecord, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords/").concat(inventoryRecordID), __assign(__assign({}, requestOptions), { data: inventoryRecord, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an inventory record variant assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/delete-variant-assignment|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param inventoryRecordID ID of the inventory record.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.DeleteVariantAssignment = function (productID, variantID, inventoryRecordID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords/").concat(inventoryRecordID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of inventory record variant assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/list-variant-assignments|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.inventoryRecordID ID of the inventory record.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the inventory record assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.ListVariantAssignments = function (productID, variantID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an inventory record variant assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/inventory-records/save-variant-assignment|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param inventoryRecordAssignment Required fields: InventoryRecordID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    InventoryRecords.prototype.SaveVariantAssignment = function (productID, variantID, inventoryRecordAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords/assignments"), __assign(__assign({}, requestOptions), { data: inventoryRecordAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * InventoryRecords.As().List() // lists InventoryRecords using the impersonated users' token
     */
    InventoryRecords.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return InventoryRecords;
}());
var InventoryRecords$1 = new InventoryRecords();

var Bundles = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Bundles() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.DeleteProductAssignment = this.DeleteProductAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
        this.ListProductAssignments = this.ListProductAssignments.bind(this);
        this.SaveProductAssignment = this.SaveProductAssignment.bind(this);
    }
    /**
     * Get a list of bundles.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/list|api docs} for more info
     *
     * @param listOptions.catalogID ID of the catalog.
     * @param listOptions.categoryID ID of the category.
     * @param listOptions.supplierID ID of the supplier.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/bundles", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new bundle. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/create|api docs} for more info
     *
     * @param bundle Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.Create = function (bundle, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/bundles", __assign(__assign({}, requestOptions), { data: bundle, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single bundle.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/get|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.Get = function (bundleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/bundles/".concat(bundleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a bundle. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/save|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param bundle Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.Save = function (bundleID, bundle, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/bundles/".concat(bundleID), __assign(__assign({}, requestOptions), { data: bundle, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a bundle.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/delete|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.Delete = function (bundleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/bundles/".concat(bundleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a bundle.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/patch|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param bundle
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.Patch = function (bundleID, bundle, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/bundles/".concat(bundleID), __assign(__assign({}, requestOptions), { data: bundle, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a bundle assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/delete-assignment|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.sellerID ID of the seller.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.DeleteAssignment = function (bundleID, buyerID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/bundles/".concat(bundleID, "/assignments/").concat(buyerID), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a bundle product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/delete-product-assignment|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.DeleteProductAssignment = function (bundleID, productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/bundles/".concat(bundleID, "/productassignments/").concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of bundle assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/list-assignments|api docs} for more info
     *
     * @param listOptions.bundleID ID of the bundle.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the bundle assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/bundles/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a bundle assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/save-assignment|api docs} for more info
     *
     * @param bundleAssignment Required fields: BundleID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.SaveAssignment = function (bundleAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/bundles/assignments", __assign(__assign({}, requestOptions), { data: bundleAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of bundle product assignments.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/list-product-assignments|api docs} for more info
     *
     * @param listOptions.bundleID ID of the bundle.
     * @param listOptions.productID ID of the product.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.ListProductAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/bundles/productassignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a bundle product assignment.
     * Check out the {@link https://ordercloud.io/api-reference/product-catalogs/bundles/save-product-assignment|api docs} for more info
     *
     * @param bundleProductAssignment Required fields: ProductID, BundleID, Required
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Bundles.prototype.SaveProductAssignment = function (bundleProductAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/bundles/productassignments", __assign(__assign({}, requestOptions), { data: bundleProductAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Bundles.As().List() // lists Bundles using the impersonated users' token
     */
    Bundles.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Bundles;
}());
var Bundles$1 = new Bundles();

var Orders = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Orders() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ApplyPromotions = this.ApplyPromotions.bind(this);
        this.ListApprovals = this.ListApprovals.bind(this);
        this.Approve = this.Approve.bind(this);
        this.SetBillingAddress = this.SetBillingAddress.bind(this);
        this.PatchBillingAddress = this.PatchBillingAddress.bind(this);
        this.Cancel = this.Cancel.bind(this);
        this.Complete = this.Complete.bind(this);
        this.Decline = this.Decline.bind(this);
        this.ListEligibleApprovers = this.ListEligibleApprovers.bind(this);
        this.ListEligiblePromotions = this.ListEligiblePromotions.bind(this);
        this.Forward = this.Forward.bind(this);
        this.PatchFromUser = this.PatchFromUser.bind(this);
        this.ListPromotions = this.ListPromotions.bind(this);
        this.AddPromotion = this.AddPromotion.bind(this);
        this.RemovePromotion = this.RemovePromotion.bind(this);
        this.Ship = this.Ship.bind(this);
        this.ListShipments = this.ListShipments.bind(this);
        this.SetShippingAddress = this.SetShippingAddress.bind(this);
        this.PatchShippingAddress = this.PatchShippingAddress.bind(this);
        this.Split = this.Split.bind(this);
        this.Submit = this.Submit.bind(this);
        this.Validate = this.Validate.bind(this);
    }
    /**
     * Get a list of orders.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/list|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.supplierID ID of the supplier.
     * @param listOptions.from Lower bound of date range that the order was created.
     * @param listOptions.to Upper bound of date range that the order was created.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.List = function (direction, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new order. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/create|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param order
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Create = function (direction, order, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction), __assign(__assign({}, requestOptions), { data: order, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/get|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Get = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an order. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/save|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param order
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Save = function (direction, orderID, order, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/orders/".concat(direction, "/").concat(orderID), __assign(__assign({}, requestOptions), { data: order, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/delete|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Delete = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orders/".concat(direction, "/").concat(orderID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/patch|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param order
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Patch = function (direction, orderID, order, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orders/".concat(direction, "/").concat(orderID), __assign(__assign({}, requestOptions), { data: order, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * AutoApply eligible promotions. Apply up to 100 eligible promotions to an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/apply-promotions|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.ApplyPromotions = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/applypromotions"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of order approvals. Returns all Approvals associated with the Order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/list-approvals|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.ListApprovals = function (direction, orderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/approvals"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Approve an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/approve|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param orderApprovalInfo
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Approve = function (direction, orderID, orderApprovalInfo, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/approve"), __assign(__assign({}, requestOptions), { data: orderApprovalInfo, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set a billing address. Use only when the address is not to be saved/reused.<br/></br>To use a saved address (i.e. from the Addresses resource), PATCH the order's BillingAddressID property instead.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/set-billing-address|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.SetBillingAddress = function (direction, orderID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/orders/".concat(direction, "/").concat(orderID, "/billto"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an order billing address. Not allowed on unsubmitted orders where BillingAddressID has been set. In that case, use the Addresses resource to update the saved address.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/patch-billing-address|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.PatchBillingAddress = function (direction, orderID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orders/".concat(direction, "/").concat(orderID, "/billto"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Cancel an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/cancel|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Cancel = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/cancel"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Complete an order. Use only when an order doesn't need a shipment. You will not be able to ship or reopen an order after completing it.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/complete|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Complete = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/complete"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Decline an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/decline|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param orderApprovalInfo
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Decline = function (direction, orderID, orderApprovalInfo, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/decline"), __assign(__assign({}, requestOptions), { data: orderApprovalInfo, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of order eligible approvers. Returns all Users who can approve or decline this order (but have not done so).
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/list-eligible-approvers|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.ListEligibleApprovers = function (direction, orderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/eligibleapprovers"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List eligible promotions. Get a list of promotions eligible for an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/list-eligible-promotions|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.ListEligiblePromotions = function (direction, orderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/eligiblepromotions"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Forward an order. Creates and submits 0 or more outgoing Orders to Suppliers, one for each unique Product.DefaultSupplierID on this Order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/forward|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Forward = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/forward"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update order FromUser. Only FirstName, LastName, and Email can be updated.<br/></br>Primarily used to facilitate guest checkout scenarios.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/patch-from-user|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param user
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.PatchFromUser = function (direction, orderID, user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orders/".concat(direction, "/").concat(orderID, "/fromuser"), __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of order promotions.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/list-promotions|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.ListPromotions = function (direction, orderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/promotions"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add a promotion to an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/add-promotion|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param promoCode Promo code of the order promotion.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.AddPromotion = function (direction, orderID, promoCode, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/promotions/").concat(promoCode), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove a promotion from an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/remove-promotion|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param promoCode Promo code of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.RemovePromotion = function (direction, orderID, promoCode, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orders/".concat(direction, "/").concat(orderID, "/promotions/").concat(promoCode), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new shipment containing all items on an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/ship|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param shipment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Ship = function (direction, orderID, shipment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/ship"), __assign(__assign({}, requestOptions), { data: shipment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List shipments for an order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/list-shipments|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.ListShipments = function (direction, orderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/shipments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set a shipping address. Use only when the address is not to be saved/reused. To use a saved address (i.e. from the Addresses resource), PATCH the order's ShippingAddressID property instead. The address used will be populated on the ShippingAddress property of each LineItem.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/set-shipping-address|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.SetShippingAddress = function (direction, orderID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/orders/".concat(direction, "/").concat(orderID, "/shipto"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an order shipping address. Not allowed on unsubmitted orders where ShippingAddressID has been set. In that case, use the Addresses resource to update the saved address.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/patch-shipping-address|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.PatchShippingAddress = function (direction, orderID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orders/".concat(direction, "/").concat(orderID, "/shipto"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Split an order. Creates, but does not submit, 0 or more outgoing Orders to Suppliers, one for each unique Product.DefaultSupplierID on this Order.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/split|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Split = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/split"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Submit an order submit.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/submit|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Submit = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/submit"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validate an order in its current state.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/orders/validate|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Orders.prototype.Validate = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/validate"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Orders.As().List() // lists Orders using the impersonated users' token
     */
    Orders.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Orders;
}());
var Orders$1 = new Orders();

var Cart = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Cart() {
        this.impersonating = false;
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.SetActiveCart = this.SetActiveCart.bind(this);
        this.ApplyPromotions = this.ApplyPromotions.bind(this);
        this.SetBillingAddress = this.SetBillingAddress.bind(this);
        this.PatchBillingAddress = this.PatchBillingAddress.bind(this);
        this.CreateBundleItem = this.CreateBundleItem.bind(this);
        this.DeleteBundleItem = this.DeleteBundleItem.bind(this);
        this.Calculate = this.Calculate.bind(this);
        this.ListEligiblePromotions = this.ListEligiblePromotions.bind(this);
        this.EstimateShipping = this.EstimateShipping.bind(this);
        this.PatchFromUser = this.PatchFromUser.bind(this);
        this.ListLineItems = this.ListLineItems.bind(this);
        this.CreateLineItem = this.CreateLineItem.bind(this);
        this.GetLineItem = this.GetLineItem.bind(this);
        this.SaveLineItem = this.SaveLineItem.bind(this);
        this.DeleteLineItem = this.DeleteLineItem.bind(this);
        this.PatchLineItem = this.PatchLineItem.bind(this);
        this.ListPayments = this.ListPayments.bind(this);
        this.CreatePayment = this.CreatePayment.bind(this);
        this.GetPayment = this.GetPayment.bind(this);
        this.DeletePayment = this.DeletePayment.bind(this);
        this.PatchPayment = this.PatchPayment.bind(this);
        this.CreatePaymentTransaction = this.CreatePaymentTransaction.bind(this);
        this.DeletePaymentTransaction = this.DeletePaymentTransaction.bind(this);
        this.ListPromotions = this.ListPromotions.bind(this);
        this.AddPromotion = this.AddPromotion.bind(this);
        this.DeletePromotion = this.DeletePromotion.bind(this);
        this.SelectShipMethods = this.SelectShipMethods.bind(this);
        this.SetShippingAddress = this.SetShippingAddress.bind(this);
        this.PatchShippingAddress = this.PatchShippingAddress.bind(this);
        this.Submit = this.Submit.bind(this);
        this.Validate = this.Validate.bind(this);
        this.GetOrderWorksheet = this.GetOrderWorksheet.bind(this);
    }
    /**
     * Get a single cart. If the ID of the Order returned is null, the cart has not yet been interacted with. Once an item is added, the Order.ID will be populated.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/get|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.Get = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a cart. If an object with the same ID already exists, it will be overwritten.<br/></br>The recommended way to initiate a new cart is to add a line item. If there is a specific reason an order needs to exist prior to adding a line item, this method can be used to initiate a new cart.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/save|api docs} for more info
     *
     * @param order
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.Save = function (order, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/cart", __assign(__assign({}, requestOptions), { data: order, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cart. Empties the cart. Any promotions, payments or other items associated with the cart will also be removed.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/delete|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.Delete = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/cart", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a cart.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/patch|api docs} for more info
     *
     * @param order
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.Patch = function (order, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/cart", __assign(__assign({}, requestOptions), { data: order, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set an active cart.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/set-active-cart|api docs} for more info
     *
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.SetActiveCart = function (orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/cart/".concat(orderID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * AutoApply eligible promotions. Apply up to 100 eligible promotions to the cart.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/apply-promotions|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.ApplyPromotions = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/applypromotions", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set a billing address. Use only when the address is not to be saved/reused.<br/></br>To use a saved address (i.e. from the Addresses resource), PATCH the order's BillingAddressID property instead.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/set-billing-address|api docs} for more info
     *
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.SetBillingAddress = function (address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/cart/billto", __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a cart billing address. Not allowed on carts where BillingAddressID has been set. In that case, use the Addresses resource to update the saved address.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/patch-billing-address|api docs} for more info
     *
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.PatchBillingAddress = function (address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/cart/billto", __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new cart bundle item. Adds bundle line items to the cart
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/create-bundle-item|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param bundleItems
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.CreateBundleItem = function (bundleID, bundleItems, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/bundles/".concat(bundleID), __assign(__assign({}, requestOptions), { data: bundleItems, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cart bundle item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/delete-bundle-item|api docs} for more info
     *
     * @param bundleID ID of the bundle.
     * @param bundleItemID ID of the bundle item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.DeleteBundleItem = function (bundleID, bundleItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/cart/bundles/".concat(bundleID, "/").concat(bundleItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Calculate the cart.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/calculate|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.Calculate = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/calculate", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List eligible promotions. Get a list of promotions eligible for the cart.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/list-eligible-promotions|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.ListEligiblePromotions = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart/eligiblepromotions", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Estimate shipping cost.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/estimate-shipping|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.EstimateShipping = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/estimateshipping", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update cart FromUser. Only FirstName, LastName, and Email can be updated.<br/></br>Primarily used to facilitate guest checkout scenarios.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/patch-from-user|api docs} for more info
     *
     * @param user
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.PatchFromUser = function (user, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/cart/fromuser", __assign(__assign({}, requestOptions), { data: user, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of cart line items.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/list-line-items|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.ListLineItems = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart/lineitems", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new cart line item. Adds a line item to the cart
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/create-line-item|api docs} for more info
     *
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.CreateLineItem = function (lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/lineitems", __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single cart line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/get-line-item|api docs} for more info
     *
     * @param lineItemID ID of the line item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.GetLineItem = function (lineItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart/lineitems/".concat(lineItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a cart line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/save-line-item|api docs} for more info
     *
     * @param lineItemID ID of the line item.
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.SaveLineItem = function (lineItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/cart/lineitems/".concat(lineItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cart line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/delete-line-item|api docs} for more info
     *
     * @param lineItemID ID of the line item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.DeleteLineItem = function (lineItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/cart/lineitems/".concat(lineItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a cart line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/patch-line-item|api docs} for more info
     *
     * @param lineItemID ID of the line item.
     * @param lineItem
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.PatchLineItem = function (lineItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/cart/lineitems/".concat(lineItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of cart payments.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/list-payments|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.ListPayments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart/payments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new cart payment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/create-payment|api docs} for more info
     *
     * @param payment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.CreatePayment = function (payment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/payments", __assign(__assign({}, requestOptions), { data: payment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single cart payment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/get-payment|api docs} for more info
     *
     * @param paymentID ID of the payment.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.GetPayment = function (paymentID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart/payments/".concat(paymentID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cart payment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/delete-payment|api docs} for more info
     *
     * @param paymentID ID of the payment.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.DeletePayment = function (paymentID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/cart/payments/".concat(paymentID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a cart payment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/patch-payment|api docs} for more info
     *
     * @param paymentID ID of the payment.
     * @param payment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.PatchPayment = function (paymentID, payment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/cart/payments/".concat(paymentID), __assign(__assign({}, requestOptions), { data: payment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new cart payment transaction.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/create-payment-transaction|api docs} for more info
     *
     * @param paymentID ID of the payment.
     * @param paymentTransaction Required fields: Type, DateExecuted
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.CreatePaymentTransaction = function (paymentID, paymentTransaction, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/payments/".concat(paymentID, "/transactions"), __assign(__assign({}, requestOptions), { data: paymentTransaction, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cart payment transaction.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/delete-payment-transaction|api docs} for more info
     *
     * @param paymentID ID of the payment.
     * @param transactionID ID of the transaction.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.DeletePaymentTransaction = function (paymentID, transactionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/cart/payments/".concat(paymentID, "/transactions/").concat(transactionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of cart promotions.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/list-promotions|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.ListPromotions = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart/promotions", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add a promotion.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/add-promotion|api docs} for more info
     *
     * @param promoCode Promo code of the order promotion.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.AddPromotion = function (promoCode, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/promotions/".concat(promoCode), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a cart promotion.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/delete-promotion|api docs} for more info
     *
     * @param promoCode Promo code of the cart.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.DeletePromotion = function (promoCode, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/cart/promotions/".concat(promoCode), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Select a ship method.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/select-ship-methods|api docs} for more info
     *
     * @param orderShipMethodSelection
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.SelectShipMethods = function (orderShipMethodSelection, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/shipmethods", __assign(__assign({}, requestOptions), { data: orderShipMethodSelection, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set a shipping address. Use only when the address is not to be saved/reused. To use a saved address (i.e. from the Addresses resource), PATCH the order's ShippingAddressID property instead. The address used will be populated on the ShippingAddress property of each LineItem.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/set-shipping-address|api docs} for more info
     *
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.SetShippingAddress = function (address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/cart/shipto", __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a cart shipping address. Not allowed on carts where ShippingAddressID has been set. In that case, use the Addresses resource to update the saved address.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/patch-shipping-address|api docs} for more info
     *
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.PatchShippingAddress = function (address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/cart/shipto", __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Submit the cart.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/submit|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.Submit = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/submit", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validate a cart validate.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/validate|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.Validate = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/cart/validate", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single cart order worksheet.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/cart/get-order-worksheet|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Cart.prototype.GetOrderWorksheet = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/cart/worksheet", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Cart.As().List() // lists Cart using the impersonated users' token
     */
    Cart.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Cart;
}());
var Cart$1 = new Cart();

var LineItems = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function LineItems() {
        this.impersonating = false;
        this.ListAcrossOrders = this.ListAcrossOrders.bind(this);
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.SetShippingAddress = this.SetShippingAddress.bind(this);
        this.PatchShippingAddress = this.PatchShippingAddress.bind(this);
    }
    /**
     * Get a list of line item across orders.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/list-across-orders|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.supplierID ID of the supplier.
     * @param listOptions.from Lower bound of date range that the order was created.
     * @param listOptions.to Upper bound of date range that the order was created.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.ListAcrossOrders = function (direction, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/lineitems/".concat(direction), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of line items.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/list|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.List = function (direction, orderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/lineitems"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new line item. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/create|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.Create = function (direction, orderID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/lineitems"), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/get|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.Get = function (direction, orderID, lineItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/lineitems/").concat(lineItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a line item. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/save|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.Save = function (direction, orderID, lineItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/orders/".concat(direction, "/").concat(orderID, "/lineitems/").concat(lineItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/delete|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.Delete = function (direction, orderID, lineItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orders/".concat(direction, "/").concat(orderID, "/lineitems/").concat(lineItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/patch|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param lineItem
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.Patch = function (direction, orderID, lineItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orders/".concat(direction, "/").concat(orderID, "/lineitems/").concat(lineItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set a shipping address. Set the Shipping Address of the Line Item. Appropriate only when the Address is not to be saved/reused. To use a Saved Address (i.e. from the Addresses resource), PATCH the Line Item's ShippingAddressID property instead.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/set-shipping-address|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.SetShippingAddress = function (direction, orderID, lineItemID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/orders/".concat(direction, "/").concat(orderID, "/lineitems/").concat(lineItemID, "/shipto"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a line item shipping address. Partially update the Shipping Address of the Line Item. Not allowed on unsubmitted Line Items where ShippingAddressID has been set. In that case, use the Addresses resource to update the Saved Address.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/line-items/patch-shipping-address|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param address
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    LineItems.prototype.PatchShippingAddress = function (direction, orderID, lineItemID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orders/".concat(direction, "/").concat(orderID, "/lineitems/").concat(lineItemID, "/shipto"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * LineItems.As().List() // lists LineItems using the impersonated users' token
     */
    LineItems.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return LineItems;
}());
var LineItems$1 = new LineItems();

var Promotions = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Promotions() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
    }
    /**
     * Get a list of promotions.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/promotions", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new promotion. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/create|api docs} for more info
     *
     * @param promotion Required fields: Code, EligibleExpression, ValueExpression
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.Create = function (promotion, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/promotions", __assign(__assign({}, requestOptions), { data: promotion, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single promotion.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/get|api docs} for more info
     *
     * @param promotionID ID of the promotion.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.Get = function (promotionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/promotions/".concat(promotionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a promotion. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/save|api docs} for more info
     *
     * @param promotionID ID of the promotion.
     * @param promotion Required fields: Code, EligibleExpression, ValueExpression
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.Save = function (promotionID, promotion, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/promotions/".concat(promotionID), __assign(__assign({}, requestOptions), { data: promotion, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a promotion.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/delete|api docs} for more info
     *
     * @param promotionID ID of the promotion.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.Delete = function (promotionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/promotions/".concat(promotionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a promotion.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/patch|api docs} for more info
     *
     * @param promotionID ID of the promotion.
     * @param promotion
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.Patch = function (promotionID, promotion, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/promotions/".concat(promotionID), __assign(__assign({}, requestOptions), { data: promotion, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a promotion assignment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/delete-assignment|api docs} for more info
     *
     * @param promotionID ID of the promotion.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.DeleteAssignment = function (promotionID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/promotions/".concat(promotionID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of promotion assignments.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/list-assignments|api docs} for more info
     *
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.promotionID ID of the promotion.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the promotion assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/promotions/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a promotion assignment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/promotions/save-assignment|api docs} for more info
     *
     * @param promotionAssignment Required fields: PromotionID, BuyerID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Promotions.prototype.SaveAssignment = function (promotionAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/promotions/assignments", __assign(__assign({}, requestOptions), { data: promotionAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Promotions.As().List() // lists Promotions using the impersonated users' token
     */
    Promotions.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Promotions;
}());
var Promotions$1 = new Promotions();

var Payments = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Payments() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.CreateTransaction = this.CreateTransaction.bind(this);
        this.DeleteTransaction = this.DeleteTransaction.bind(this);
    }
    /**
     * Get a list of payments.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/payments/list|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Payments.prototype.List = function (direction, orderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/payments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new payment. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/payments/create|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param payment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Payments.prototype.Create = function (direction, orderID, payment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/payments"), __assign(__assign({}, requestOptions), { data: payment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single payment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/payments/get|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param paymentID ID of the payment.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Payments.prototype.Get = function (direction, orderID, paymentID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/payments/").concat(paymentID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a payment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/payments/delete|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param paymentID ID of the payment.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Payments.prototype.Delete = function (direction, orderID, paymentID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orders/".concat(direction, "/").concat(orderID, "/payments/").concat(paymentID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a payment. PUT is not a supported method for payments due to the implications associated with modifying certain properties. Patch is only permitted on certain properties that vary depending on order status
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/payments/patch|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param paymentID ID of the payment.
     * @param payment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Payments.prototype.Patch = function (direction, orderID, paymentID, payment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orders/".concat(direction, "/").concat(orderID, "/payments/").concat(paymentID), __assign(__assign({}, requestOptions), { data: payment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new payment transaction.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/payments/create-transaction|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param paymentID ID of the payment.
     * @param paymentTransaction Required fields: Type, DateExecuted
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Payments.prototype.CreateTransaction = function (direction, orderID, paymentID, paymentTransaction, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/payments/").concat(paymentID, "/transactions"), __assign(__assign({}, requestOptions), { data: paymentTransaction, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a payment transaction.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/payments/delete-transaction|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param paymentID ID of the payment.
     * @param transactionID ID of the transaction.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Payments.prototype.DeleteTransaction = function (direction, orderID, paymentID, transactionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orders/".concat(direction, "/").concat(orderID, "/payments/").concat(paymentID, "/transactions/").concat(transactionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Payments.As().List() // lists Payments using the impersonated users' token
     */
    Payments.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Payments;
}());
var Payments$1 = new Payments();

var Shipments = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Shipments() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ListItems = this.ListItems.bind(this);
        this.SaveItem = this.SaveItem.bind(this);
        this.GetItem = this.GetItem.bind(this);
        this.DeleteItem = this.DeleteItem.bind(this);
        this.SetShipFromAddress = this.SetShipFromAddress.bind(this);
        this.SetShipToAddress = this.SetShipToAddress.bind(this);
    }
    /**
     * Get a list of shipments.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/list|api docs} for more info
     *
     * @param listOptions.orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/shipments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new shipment. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/create|api docs} for more info
     *
     * @param shipment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.Create = function (shipment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/shipments", __assign(__assign({}, requestOptions), { data: shipment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single shipment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/get|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.Get = function (shipmentID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/shipments/".concat(shipmentID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a shipment. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/save|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param shipment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.Save = function (shipmentID, shipment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/shipments/".concat(shipmentID), __assign(__assign({}, requestOptions), { data: shipment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a shipment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/delete|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.Delete = function (shipmentID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/shipments/".concat(shipmentID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a shipment.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/patch|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param shipment
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.Patch = function (shipmentID, shipment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/shipments/".concat(shipmentID), __assign(__assign({}, requestOptions), { data: shipment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of shipment items.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/list-items|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.ListItems = function (shipmentID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/shipments/".concat(shipmentID, "/items"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a shipment item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/save-item|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param shipmentItem Required fields: OrderID, LineItemID, QuantityShipped
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.SaveItem = function (shipmentID, shipmentItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/shipments/".concat(shipmentID, "/items"), __assign(__assign({}, requestOptions), { data: shipmentItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single shipment item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/get-item|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.GetItem = function (shipmentID, orderID, lineItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/shipments/".concat(shipmentID, "/items/").concat(orderID, "/").concat(lineItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a shipment item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/delete-item|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param orderID ID of the order.
     * @param lineItemID ID of the line item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.DeleteItem = function (shipmentID, orderID, lineItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/shipments/".concat(shipmentID, "/items/").concat(orderID, "/").concat(lineItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set a ship from address. Use only when the address is not to be saved/reused. To use a saved address (i.e. from the Addresses resource), PATCH the shipment's FromAddressID property instead.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/set-ship-from-address|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.SetShipFromAddress = function (shipmentID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/shipments/".concat(shipmentID, "/shipfrom"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set a ship to address. Use only when the address is not to be saved/reused. To use a saved address (i.e. from the Addresses resource), PATCH the shipment's ToAddressID property instead.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/shipments/set-ship-to-address|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param address Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Shipments.prototype.SetShipToAddress = function (shipmentID, address, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/shipments/".concat(shipmentID, "/shipto"), __assign(__assign({}, requestOptions), { data: address, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Shipments.As().List() // lists Shipments using the impersonated users' token
     */
    Shipments.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Shipments;
}());
var Shipments$1 = new Shipments();

var OrderReturns = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function OrderReturns() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ListApprovals = this.ListApprovals.bind(this);
        this.Approve = this.Approve.bind(this);
        this.Cancel = this.Cancel.bind(this);
        this.Complete = this.Complete.bind(this);
        this.Decline = this.Decline.bind(this);
        this.ListEligibleApprovers = this.ListEligibleApprovers.bind(this);
        this.DeleteItem = this.DeleteItem.bind(this);
        this.Submit = this.Submit.bind(this);
    }
    /**
     * Get a list of order returns.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/list|api docs} for more info
     *
     * @param listOptions.approvable Only returns orders awaiting the user's approval if true.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orderreturns", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new order return. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/create|api docs} for more info
     *
     * @param orderReturn Required fields: OrderID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Create = function (orderReturn, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orderreturns", __assign(__assign({}, requestOptions), { data: orderReturn, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single order return.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/get|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Get = function (returnID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orderreturns/".concat(returnID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an order return. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/save|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param orderReturn Required fields: OrderID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Save = function (returnID, orderReturn, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/orderreturns/".concat(returnID), __assign(__assign({}, requestOptions), { data: orderReturn, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an order return.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/delete|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Delete = function (returnID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orderreturns/".concat(returnID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an order return.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/patch|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param orderReturn
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Patch = function (returnID, orderReturn, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/orderreturns/".concat(returnID), __assign(__assign({}, requestOptions), { data: orderReturn, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of order return approvals. Returns all Approvals associated with the Order Return.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/list-approvals|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.ListApprovals = function (returnID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orderreturns/".concat(returnID, "/approvals"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Approve an order return.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/approve|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param approvalInfo
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Approve = function (returnID, approvalInfo, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orderreturns/".concat(returnID, "/approve"), __assign(__assign({}, requestOptions), { data: approvalInfo, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Cancel an OrderReturn.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/cancel|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Cancel = function (returnID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orderreturns/".concat(returnID, "/cancel"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Complete an OrderReturn. Use only when an order return won't have an associated payment. You will not to reopen an order return after completing it.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/complete|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Complete = function (returnID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orderreturns/".concat(returnID, "/complete"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Decline an order return.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/decline|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param approvalInfo
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Decline = function (returnID, approvalInfo, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orderreturns/".concat(returnID, "/decline"), __assign(__assign({}, requestOptions), { data: approvalInfo, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of order return eligible approvers. Returns all Users who can approve or decline this order return (but have not done so).
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/list-eligible-approvers|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.ListEligibleApprovers = function (returnID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orderreturns/".concat(returnID, "/eligibleapprovers"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an order return item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/delete-item|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param lineItemID ID of the line item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.DeleteItem = function (returnID, lineItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orderreturns/".concat(returnID, "/items/").concat(lineItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Submit an order return submit.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/order-returns/submit|api docs} for more info
     *
     * @param returnID ID of the return.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderReturns.prototype.Submit = function (returnID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orderreturns/".concat(returnID, "/submit"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * OrderReturns.As().List() // lists OrderReturns using the impersonated users' token
     */
    OrderReturns.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return OrderReturns;
}());
var OrderReturns$1 = new OrderReturns();

var SellerApprovalRules = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SellerApprovalRules() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of seller approval rules.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/seller-approval-rules/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SellerApprovalRules.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/approvalrules", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new seller approval rule. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/seller-approval-rules/create|api docs} for more info
     *
     * @param sellerApprovalRule Required fields: ApprovalType, ApprovingGroupID, RuleExpression
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SellerApprovalRules.prototype.Create = function (sellerApprovalRule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/approvalrules", __assign(__assign({}, requestOptions), { data: sellerApprovalRule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single seller approval rule.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/seller-approval-rules/get|api docs} for more info
     *
     * @param approvalRuleID ID of the approval rule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SellerApprovalRules.prototype.Get = function (approvalRuleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/approvalrules/".concat(approvalRuleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a seller approval rule. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/seller-approval-rules/save|api docs} for more info
     *
     * @param approvalRuleID ID of the approval rule.
     * @param sellerApprovalRule Required fields: ApprovalType, ApprovingGroupID, RuleExpression
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SellerApprovalRules.prototype.Save = function (approvalRuleID, sellerApprovalRule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/approvalrules/".concat(approvalRuleID), __assign(__assign({}, requestOptions), { data: sellerApprovalRule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a seller approval rule.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/seller-approval-rules/delete|api docs} for more info
     *
     * @param approvalRuleID ID of the approval rule.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SellerApprovalRules.prototype.Delete = function (approvalRuleID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/approvalrules/".concat(approvalRuleID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a seller approval rule.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/seller-approval-rules/patch|api docs} for more info
     *
     * @param approvalRuleID ID of the approval rule.
     * @param sellerApprovalRule
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SellerApprovalRules.prototype.Patch = function (approvalRuleID, sellerApprovalRule, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/approvalrules/".concat(approvalRuleID), __assign(__assign({}, requestOptions), { data: sellerApprovalRule, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SellerApprovalRules.As().List() // lists SellerApprovalRules using the impersonated users' token
     */
    SellerApprovalRules.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SellerApprovalRules;
}());
var SellerApprovalRules$1 = new SellerApprovalRules();

var BundleLineItems = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function BundleLineItems() {
        this.impersonating = false;
        this.Create = this.Create.bind(this);
        this.Delete = this.Delete.bind(this);
    }
    /**
     * Create a new bundle line item. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/bundle-line-items/create|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param bundleID ID of the bundle.
     * @param bundleItems
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    BundleLineItems.prototype.Create = function (direction, orderID, bundleID, bundleItems, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/bundles/").concat(bundleID), __assign(__assign({}, requestOptions), { data: bundleItems, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a bundle line item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/bundle-line-items/delete|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param bundleID ID of the bundle.
     * @param bundleItemID ID of the bundle item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    BundleLineItems.prototype.Delete = function (direction, orderID, bundleID, bundleItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/orders/".concat(direction, "/").concat(orderID, "/bundles/").concat(bundleID, "/").concat(bundleItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * BundleLineItems.As().List() // lists BundleLineItems using the impersonated users' token
     */
    BundleLineItems.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return BundleLineItems;
}());
var BundleLineItems$1 = new BundleLineItems();

var BundleSubscriptionItems = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function BundleSubscriptionItems() {
        this.impersonating = false;
        this.Create = this.Create.bind(this);
        this.Delete = this.Delete.bind(this);
    }
    /**
     * Create a new bundle subscription item. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/bundle-subscription-items/create|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param bundleID ID of the bundle.
     * @param bundleItems
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    BundleSubscriptionItems.prototype.Create = function (subscriptionID, bundleID, bundleItems, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/subscriptions/".concat(subscriptionID, "/bundles/").concat(bundleID), __assign(__assign({}, requestOptions), { data: bundleItems, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a bundle subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/bundle-subscription-items/delete|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param bundleID ID of the bundle.
     * @param bundleItemID ID of the bundle item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    BundleSubscriptionItems.prototype.Delete = function (subscriptionID, bundleID, bundleItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/subscriptions/".concat(subscriptionID, "/bundles/").concat(bundleID, "/").concat(bundleItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * BundleSubscriptionItems.As().List() // lists BundleSubscriptionItems using the impersonated users' token
     */
    BundleSubscriptionItems.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return BundleSubscriptionItems;
}());
var BundleSubscriptionItems$1 = new BundleSubscriptionItems();

var SubscriptionItems = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SubscriptionItems() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of subscription items.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscription-items/list|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionItems.prototype.List = function (subscriptionID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/subscriptions/".concat(subscriptionID, "/items"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new subscription item. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscription-items/create|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionItems.prototype.Create = function (subscriptionID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/subscriptions/".concat(subscriptionID, "/items"), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscription-items/get|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionItems.prototype.Get = function (subscriptionID, subscriptionItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a subscription item. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscription-items/save|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionItems.prototype.Save = function (subscriptionID, subscriptionItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscription-items/delete|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionItems.prototype.Delete = function (subscriptionID, subscriptionItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscription-items/patch|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param lineItem
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionItems.prototype.Patch = function (subscriptionID, subscriptionItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SubscriptionItems.As().List() // lists SubscriptionItems using the impersonated users' token
     */
    SubscriptionItems.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SubscriptionItems;
}());
var SubscriptionItems$1 = new SubscriptionItems();

var Subscriptions = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Subscriptions() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of subscriptions.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscriptions/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Subscriptions.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/subscriptions", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new subscription. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscriptions/create|api docs} for more info
     *
     * @param subscription Required fields: Frequency, Interval, NextOrderDate
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Subscriptions.prototype.Create = function (subscription, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/subscriptions", __assign(__assign({}, requestOptions), { data: subscription, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single subscription.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscriptions/get|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Subscriptions.prototype.Get = function (subscriptionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a subscription. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscriptions/save|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscription Required fields: Frequency, Interval, NextOrderDate
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Subscriptions.prototype.Save = function (subscriptionID, subscription, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { data: subscription, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a subscription.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscriptions/delete|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Subscriptions.prototype.Delete = function (subscriptionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a subscription.
     * Check out the {@link https://ordercloud.io/api-reference/orders-and-fulfillment/subscriptions/patch|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscription
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Subscriptions.prototype.Patch = function (subscriptionID, subscription, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { data: subscription, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Subscriptions.As().List() // lists Subscriptions using the impersonated users' token
     */
    Subscriptions.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Subscriptions;
}());
var Subscriptions$1 = new Subscriptions();

var Me = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function Me() {
        this.impersonating = false;
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Patch = this.Patch.bind(this);
        this.ListAddresses = this.ListAddresses.bind(this);
        this.CreateAddress = this.CreateAddress.bind(this);
        this.GetAddress = this.GetAddress.bind(this);
        this.SaveAddress = this.SaveAddress.bind(this);
        this.DeleteAddress = this.DeleteAddress.bind(this);
        this.PatchAddress = this.PatchAddress.bind(this);
        this.ListCatalogs = this.ListCatalogs.bind(this);
        this.GetCatalog = this.GetCatalog.bind(this);
        this.ListCategories = this.ListCategories.bind(this);
        this.GetCategory = this.GetCategory.bind(this);
        this.ListCostCenters = this.ListCostCenters.bind(this);
        this.ListCreditCards = this.ListCreditCards.bind(this);
        this.CreateCreditCard = this.CreateCreditCard.bind(this);
        this.GetCreditCard = this.GetCreditCard.bind(this);
        this.SaveCreditCard = this.SaveCreditCard.bind(this);
        this.DeleteCreditCard = this.DeleteCreditCard.bind(this);
        this.PatchCreditCard = this.PatchCreditCard.bind(this);
        this.ListOrders = this.ListOrders.bind(this);
        this.TransferAnonUserOrder = this.TransferAnonUserOrder.bind(this);
        this.ListApprovableOrders = this.ListApprovableOrders.bind(this);
        this.ResetPasswordByToken = this.ResetPasswordByToken.bind(this);
        this.ListProductCollections = this.ListProductCollections.bind(this);
        this.CreateProductCollection = this.CreateProductCollection.bind(this);
        this.GetProductCollection = this.GetProductCollection.bind(this);
        this.SaveProductCollection = this.SaveProductCollection.bind(this);
        this.DeleteProductCollection = this.DeleteProductCollection.bind(this);
        this.PatchProductCollection = this.PatchProductCollection.bind(this);
        this.CreateProductCollectionEntry = this.CreateProductCollectionEntry.bind(this);
        this.DeleteProductCollectionEntry = this.DeleteProductCollectionEntry.bind(this);
        this.ListProductCollectionInvitations = this.ListProductCollectionInvitations.bind(this);
        this.CreateProductCollectionInvitation = this.CreateProductCollectionInvitation.bind(this);
        this.GetProductCollectionInvitation = this.GetProductCollectionInvitation.bind(this);
        this.DeleteProductCollectionInvitation = this.DeleteProductCollectionInvitation.bind(this);
        this.PatchProductCollectionInvitation = this.PatchProductCollectionInvitation.bind(this);
        this.AcceptProductCollectionInvitation = this.AcceptProductCollectionInvitation.bind(this);
        this.DeclineProductCollectionInvitation = this.DeclineProductCollectionInvitation.bind(this);
        this.ListProductCollectionEntries = this.ListProductCollectionEntries.bind(this);
        this.ListProducts = this.ListProducts.bind(this);
        this.GetProduct = this.GetProduct.bind(this);
        this.ListProductInventoryRecords = this.ListProductInventoryRecords.bind(this);
        this.ListProductSellers = this.ListProductSellers.bind(this);
        this.ListSpecs = this.ListSpecs.bind(this);
        this.GetSpec = this.GetSpec.bind(this);
        this.ListVariants = this.ListVariants.bind(this);
        this.GetVariant = this.GetVariant.bind(this);
        this.ListVariantInventoryRecords = this.ListVariantInventoryRecords.bind(this);
        this.ListPromotions = this.ListPromotions.bind(this);
        this.GetPromotion = this.GetPromotion.bind(this);
        this.Register = this.Register.bind(this);
        this.ListBuyerSellers = this.ListBuyerSellers.bind(this);
        this.ListShipments = this.ListShipments.bind(this);
        this.GetShipment = this.GetShipment.bind(this);
        this.ListShipmentItems = this.ListShipmentItems.bind(this);
        this.ListSpendingAccounts = this.ListSpendingAccounts.bind(this);
        this.GetSpendingAccount = this.GetSpendingAccount.bind(this);
        this.ListSubscriptions = this.ListSubscriptions.bind(this);
        this.CreateSubscription = this.CreateSubscription.bind(this);
        this.GetSubscription = this.GetSubscription.bind(this);
        this.SaveSubscription = this.SaveSubscription.bind(this);
        this.DeleteSubscription = this.DeleteSubscription.bind(this);
        this.PatchSubscription = this.PatchSubscription.bind(this);
        this.ListSubscriptionItems = this.ListSubscriptionItems.bind(this);
        this.CreateSubscriptionItem = this.CreateSubscriptionItem.bind(this);
        this.GetSubscriptionItem = this.GetSubscriptionItem.bind(this);
        this.SaveSubscriptionItem = this.SaveSubscriptionItem.bind(this);
        this.DeleteSubscriptionItem = this.DeleteSubscriptionItem.bind(this);
        this.PatchSubscriptionItem = this.PatchSubscriptionItem.bind(this);
        this.CreateSubscriptionBundleItem = this.CreateSubscriptionBundleItem.bind(this);
        this.DeleteSubscriptionBundleItem = this.DeleteSubscriptionBundleItem.bind(this);
        this.ListUserGroups = this.ListUserGroups.bind(this);
    }
    /**
     * Get the Current Authenticated User
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.Get = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update the Currently Authenticated User If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/save|api docs} for more info
     *
     * @param meUser Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.Save = function (meUser, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me", __assign(__assign({}, requestOptions), { data: meUser, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch the Currently Authenticated User.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/patch|api docs} for more info
     *
     * @param meUser
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.Patch = function (meUser, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/me", __assign(__assign({}, requestOptions), { data: meUser, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of addresses visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-addresses|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListAddresses = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/addresses", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new address. Only available to Buyer Users. Addresses created using this endpoint are considered private, and only accessible to the user who created them.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-address|api docs} for more info
     *
     * @param buyerAddress Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateAddress = function (buyerAddress, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/addresses", __assign(__assign({}, requestOptions), { data: buyerAddress, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single address. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-address|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetAddress = function (addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an address. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/save-address|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param buyerAddress Required fields: Street1, City, State, Zip, Country
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.SaveAddress = function (addressID, buyerAddress, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { data: buyerAddress, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an address. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-address|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteAddress = function (addressID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an address. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/patch-address|api docs} for more info
     *
     * @param addressID ID of the address.
     * @param buyerAddress
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.PatchAddress = function (addressID, buyerAddress, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/me/addresses/".concat(addressID), __assign(__assign({}, requestOptions), { data: buyerAddress, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of catalogs visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-catalogs|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param listOptions.sellerID ID of the seller.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListCatalogs = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/catalogs", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single catalog. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-catalog|api docs} for more info
     *
     * @param catalogID ID of the catalog.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetCatalog = function (catalogID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/catalogs/".concat(catalogID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of categories visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-categories|api docs} for more info
     *
     * @param listOptions.depth Indicates how deep down the hierarchy to return results. Valid values are a number of 1 or greater, or 'all'. Relative to ParentID if specified. Default is 1.
     * @param listOptions.catalogID The user’s default CatalogID will be used to return categories if you do not pass another CatalogID explicitly. Listing categories across multiple catalogs is not supported.
     * @param listOptions.productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListCategories = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/categories", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single category. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-category|api docs} for more info
     *
     * @param categoryID ID of the category.
     * @param listOptions.catalogID ID of the catalog.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetCategory = function (categoryID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/categories/".concat(categoryID), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of cost centers visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-cost-centers|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListCostCenters = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/costcenters", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of credit cards visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-credit-cards|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListCreditCards = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/creditcards", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new credit card. Only available to Buyer Users. Credit Cards created using this endpoint are considered private, and only accessible to the user who created them.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-credit-card|api docs} for more info
     *
     * @param buyerCreditCard
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateCreditCard = function (buyerCreditCard, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/creditcards", __assign(__assign({}, requestOptions), { data: buyerCreditCard, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single credit card. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-credit-card|api docs} for more info
     *
     * @param creditcardID ID of the creditcard.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetCreditCard = function (creditcardID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/creditcards/".concat(creditcardID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a credit card. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/save-credit-card|api docs} for more info
     *
     * @param creditcardID ID of the creditcard.
     * @param buyerCreditCard
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.SaveCreditCard = function (creditcardID, buyerCreditCard, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/creditcards/".concat(creditcardID), __assign(__assign({}, requestOptions), { data: buyerCreditCard, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a credit card. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-credit-card|api docs} for more info
     *
     * @param creditcardID ID of the creditcard.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteCreditCard = function (creditcardID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/creditcards/".concat(creditcardID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a credit card. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/patch-credit-card|api docs} for more info
     *
     * @param creditcardID ID of the creditcard.
     * @param buyerCreditCard
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.PatchCreditCard = function (creditcardID, buyerCreditCard, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/me/creditcards/".concat(creditcardID), __assign(__assign({}, requestOptions), { data: buyerCreditCard, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of orders visible to this user. List orders created by this user.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-orders|api docs} for more info
     *
     * @param listOptions.from Lower bound of date range that the order was created (if outgoing) or submitted (if incoming).
     * @param listOptions.to Upper bound of date range that the order was created (if outgoing) or submitted (if incoming).
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListOrders = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/orders", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Transfer an order. If a user begins an order as the anonymous shopper and later logs in, use this endpoint to transfer that order to them.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/transfer-anon-user-order|api docs} for more info
     *
     * @param listOptions.anonUserToken Anon user token of the me.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.TransferAnonUserOrder = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/orders", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of orders that this user can approve.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-approvable-orders|api docs} for more info
     *
     * @param listOptions.from Lower bound of date range that the order was created (if outgoing) or submitted (if incoming).
     * @param listOptions.to Upper bound of date range that the order was created (if outgoing) or submitted (if incoming).
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListApprovableOrders = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/orders/approvable", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Reset a password by token.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/reset-password-by-token|api docs} for more info
     *
     * @param tokenPasswordReset Required fields: NewPassword
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ResetPasswordByToken = function (tokenPasswordReset, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/password", __assign(__assign({}, requestOptions), { data: tokenPasswordReset, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product collections visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-product-collections|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListProductCollections = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/productcollections", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new product collection. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-product-collection|api docs} for more info
     *
     * @param productCollection Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateProductCollection = function (productCollection, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/productcollections", __assign(__assign({}, requestOptions), { data: productCollection, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single product collection. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-product-collection|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetProductCollection = function (productCollectionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/productcollections/".concat(productCollectionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a product collection. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/save-product-collection|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param productCollection Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.SaveProductCollection = function (productCollectionID, productCollection, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/productcollections/".concat(productCollectionID), __assign(__assign({}, requestOptions), { data: productCollection, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a product collection. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-product-collection|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteProductCollection = function (productCollectionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/productcollections/".concat(productCollectionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a product collection. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/patch-product-collection|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param productCollection
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.PatchProductCollection = function (productCollectionID, productCollection, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/me/productcollections/".concat(productCollectionID), __assign(__assign({}, requestOptions), { data: productCollection, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new product collection entry. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-product-collection-entry|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateProductCollectionEntry = function (productCollectionID, productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/productcollections/".concat(productCollectionID, "/").concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a product collection entry. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-product-collection-entry|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param productID ID of the product.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteProductCollectionEntry = function (productCollectionID, productID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/productcollections/".concat(productCollectionID, "/").concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product collection invitations visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-product-collection-invitations|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListProductCollectionInvitations = function (productCollectionID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/productcollections/".concat(productCollectionID, "/invitations"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new product collection invitation. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-product-collection-invitation|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param productCollectionInvitation Required fields: Name
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateProductCollectionInvitation = function (productCollectionID, productCollectionInvitation, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/productcollections/".concat(productCollectionID, "/invitations"), __assign(__assign({}, requestOptions), { data: productCollectionInvitation, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single product collection invitation. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-product-collection-invitation|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param invitationID ID of the invitation.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetProductCollectionInvitation = function (productCollectionID, invitationID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/productcollections/".concat(productCollectionID, "/invitations/").concat(invitationID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a product collection invitation. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-product-collection-invitation|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param invitationID ID of the invitation.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteProductCollectionInvitation = function (productCollectionID, invitationID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/productcollections/".concat(productCollectionID, "/invitations/").concat(invitationID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a product collection invitation. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/patch-product-collection-invitation|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param invitationID ID of the invitation.
     * @param productCollectionInvitation
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.PatchProductCollectionInvitation = function (productCollectionID, invitationID, productCollectionInvitation, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/me/productcollections/".concat(productCollectionID, "/invitations/").concat(invitationID), __assign(__assign({}, requestOptions), { data: productCollectionInvitation, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Accept a product collection invitation.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/accept-product-collection-invitation|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param invitationID ID of the invitation.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.AcceptProductCollectionInvitation = function (productCollectionID, invitationID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/productcollections/".concat(productCollectionID, "/invitations/accept/").concat(invitationID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Decline a product collection invitation.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/decline-product-collection-invitation|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param invitationID ID of the invitation.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeclineProductCollectionInvitation = function (productCollectionID, invitationID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/productcollections/".concat(productCollectionID, "/invitations/decline/").concat(invitationID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product collection entries visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-product-collection-entries|api docs} for more info
     *
     * @param productCollectionID ID of the product collection.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListProductCollectionEntries = function (productCollectionID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/productcollections/".concat(productCollectionID, "/products"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of products visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-products|api docs} for more info
     *
     * @param listOptions.catalogID ID of the catalog.
     * @param listOptions.categoryID ID of the category.
     * @param listOptions.depth Indicates how deep down the category hierarchy to return results. Valid values are a number of 1 or greater, or 'all'. Relative to CategoryID if specified, otherwise top level of the Catalog. Default is 'all'.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.searchType Type of search to perform. Possible values: AnyTerm (default), AllTermsAnyField, AllTermsSameField, ExactPhrase, ExactPhrasePrefix.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param listOptions.sellerID ID of the seller.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListProducts = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single product. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-product|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.sellerID ID of the seller.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetProduct = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product inventory records visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-product-inventory-records|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListProductInventoryRecords = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID, "/inventoryrecords"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of product sellers visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-product-sellers|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListProductSellers = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID, "/sellers"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of specs visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-specs|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.catalogID ID of the catalog.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListSpecs = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID, "/specs"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single spec. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-spec|api docs} for more info
     *
     * @param productID ID of the product.
     * @param specID ID of the spec.
     * @param listOptions.catalogID ID of the catalog.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetSpec = function (productID, specID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID, "/specs/").concat(specID), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of variants visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-variants|api docs} for more info
     *
     * @param productID ID of the product.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListVariants = function (productID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID, "/variants"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single variant. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-variant|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetVariant = function (productID, variantID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID, "/variants/").concat(variantID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of variant inventory records visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-variant-inventory-records|api docs} for more info
     *
     * @param productID ID of the product.
     * @param variantID ID of the variant.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListVariantInventoryRecords = function (productID, variantID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/products/".concat(productID, "/variants/").concat(variantID, "/inventoryrecords"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of promotions visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-promotions|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListPromotions = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/promotions", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single promotion. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-promotion|api docs} for more info
     *
     * @param promotionID ID of the promotion.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetPromotion = function (promotionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/promotions/".concat(promotionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Register a register.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/register|api docs} for more info
     *
     * @param listOptions.anonUserToken Anon user token of the user.
     * @param meUser Required fields: Username, FirstName, LastName, Email, Active
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.Register = function (meUser, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/register", __assign(__assign({}, requestOptions), { data: meUser, impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of buyer sellers visible to this user. Organizations you can place orders directly to.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-buyer-sellers|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListBuyerSellers = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/sellers", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of shipments visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-shipments|api docs} for more info
     *
     * @param listOptions.orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListShipments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/shipments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single shipment. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-shipment|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetShipment = function (shipmentID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/shipments/".concat(shipmentID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of shipment items visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-shipment-items|api docs} for more info
     *
     * @param shipmentID ID of the shipment.
     * @param listOptions.orderID ID of the order.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListShipmentItems = function (shipmentID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/shipments/".concat(shipmentID, "/items"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of spending accounts visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-spending-accounts|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListSpendingAccounts = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/spendingAccounts", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single spending account. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-spending-account|api docs} for more info
     *
     * @param spendingAccountID ID of the spending account.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetSpendingAccount = function (spendingAccountID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/spendingaccounts/".concat(spendingAccountID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of subscriptions visible to this user.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-subscriptions|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListSubscriptions = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/subscriptions", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new subscription.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-subscription|api docs} for more info
     *
     * @param subscription Required fields: Frequency, Interval, NextOrderDate
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateSubscription = function (subscription, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/subscriptions", __assign(__assign({}, requestOptions), { data: subscription, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single subscription.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-subscription|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetSubscription = function (subscriptionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a subscription.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/save-subscription|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscription Required fields: Frequency, Interval, NextOrderDate
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.SaveSubscription = function (subscriptionID, subscription, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { data: subscription, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a subscription.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-subscription|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteSubscription = function (subscriptionID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a subscription.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/patch-subscription|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscription
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.PatchSubscription = function (subscriptionID, subscription, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/me/subscriptions/".concat(subscriptionID), __assign(__assign({}, requestOptions), { data: subscription, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of subscription items visible to this user.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-subscription-items|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListSubscriptionItems = function (subscriptionID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/subscriptions/".concat(subscriptionID, "/items"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-subscription-item|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateSubscriptionItem = function (subscriptionID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/subscriptions/".concat(subscriptionID, "/items"), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/get-subscription-item|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.GetSubscriptionItem = function (subscriptionID, subscriptionItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/save-subscription-item|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param lineItem Required fields: ProductID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.SaveSubscriptionItem = function (subscriptionID, subscriptionItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/me/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-subscription-item|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteSubscriptionItem = function (subscriptionID, subscriptionItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a subscription item.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/patch-subscription-item|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param subscriptionItemID ID of the subscription item.
     * @param lineItem
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.PatchSubscriptionItem = function (subscriptionID, subscriptionItemID, lineItem, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/me/subscriptions/".concat(subscriptionID, "/items/").concat(subscriptionItemID), __assign(__assign({}, requestOptions), { data: lineItem, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new subscription bundle item.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/create-subscription-bundle-item|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param bundleID ID of the bundle.
     * @param bundleItems
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.CreateSubscriptionBundleItem = function (subscriptionID, bundleID, bundleItems, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/me/subscriptions/".concat(subscriptionID, "/items/bundles/").concat(bundleID), __assign(__assign({}, requestOptions), { data: bundleItems, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a subscription bundle item.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/delete-subscription-bundle-item|api docs} for more info
     *
     * @param subscriptionID ID of the subscription.
     * @param bundleID ID of the bundle.
     * @param bundleItemID ID of the bundle item.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.DeleteSubscriptionBundleItem = function (subscriptionID, bundleID, bundleItemID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/me/subscriptions/".concat(subscriptionID, "/items/bundles/").concat(bundleID, "/").concat(bundleItemID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of user groups visible to this user. Only available to Buyer Users.
     * Check out the {@link https://ordercloud.io/api-reference/me-and-my-stuff/me/list-user-groups|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    Me.prototype.ListUserGroups = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/me/usergroups", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * Me.As().List() // lists Me using the impersonated users' token
     */
    Me.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return Me;
}());
var Me$1 = new Me();

var TrackingEvents = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function TrackingEvents() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of tracking events.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/tracking-events/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    TrackingEvents.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/trackingEvents", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new tracking event. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/tracking-events/create|api docs} for more info
     *
     * @param trackingEvent Required fields: EventType, ClientID, Name, DeliveryConfigID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    TrackingEvents.prototype.Create = function (trackingEvent, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/integrations/trackingEvents", __assign(__assign({}, requestOptions), { data: trackingEvent, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single tracking event.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/tracking-events/get|api docs} for more info
     *
     * @param eventID ID of the event.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    TrackingEvents.prototype.Get = function (eventID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/trackingEvents/".concat(eventID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a tracking event. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/tracking-events/save|api docs} for more info
     *
     * @param eventID ID of the event.
     * @param trackingEvent Required fields: EventType, ClientID, Name, DeliveryConfigID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    TrackingEvents.prototype.Save = function (eventID, trackingEvent, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/integrations/trackingEvents/".concat(eventID), __assign(__assign({}, requestOptions), { data: trackingEvent, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a tracking event.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/tracking-events/delete|api docs} for more info
     *
     * @param eventID ID of the event.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    TrackingEvents.prototype.Delete = function (eventID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/integrations/trackingEvents/".concat(eventID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a tracking event.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/tracking-events/patch|api docs} for more info
     *
     * @param eventID ID of the event.
     * @param trackingEvent
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    TrackingEvents.prototype.Patch = function (eventID, trackingEvent, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/integrations/trackingEvents/".concat(eventID), __assign(__assign({}, requestOptions), { data: trackingEvent, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * TrackingEvents.As().List() // lists TrackingEvents using the impersonated users' token
     */
    TrackingEvents.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return TrackingEvents;
}());
var TrackingEvents$1 = new TrackingEvents();

var DeliveryConfigurations = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function DeliveryConfigurations() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a list of delivery configurations.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/delivery-configurations/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    DeliveryConfigurations.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/deliveryconfig", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new delivery configuration. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/delivery-configurations/create|api docs} for more info
     *
     * @param deliveryConfig Required fields: Name, DeliveryTargets
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    DeliveryConfigurations.prototype.Create = function (deliveryConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/integrations/deliveryconfig", __assign(__assign({}, requestOptions), { data: deliveryConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single delivery configuration.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/delivery-configurations/get|api docs} for more info
     *
     * @param deliveryConfigID ID of the delivery config.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    DeliveryConfigurations.prototype.Get = function (deliveryConfigID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/deliveryconfig/".concat(deliveryConfigID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a delivery configuration. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/delivery-configurations/save|api docs} for more info
     *
     * @param deliveryConfigID ID of the delivery config.
     * @param deliveryConfig Required fields: Name, DeliveryTargets
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    DeliveryConfigurations.prototype.Save = function (deliveryConfigID, deliveryConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/integrations/deliveryconfig/".concat(deliveryConfigID), __assign(__assign({}, requestOptions), { data: deliveryConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a delivery configuration.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/delivery-configurations/delete|api docs} for more info
     *
     * @param deliveryConfigID ID of the delivery config.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    DeliveryConfigurations.prototype.Delete = function (deliveryConfigID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/integrations/deliveryconfig/".concat(deliveryConfigID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a delivery configuration.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/delivery-configurations/patch|api docs} for more info
     *
     * @param deliveryConfigID ID of the delivery config. Required.
     * @param deliveryConfig
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    DeliveryConfigurations.prototype.Patch = function (deliveryConfigID, deliveryConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/integrations/deliveryconfig/".concat(deliveryConfigID), __assign(__assign({}, requestOptions), { data: deliveryConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * DeliveryConfigurations.As().List() // lists DeliveryConfigurations using the impersonated users' token
     */
    DeliveryConfigurations.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return DeliveryConfigurations;
}());
var DeliveryConfigurations$1 = new DeliveryConfigurations();

var ErrorConfigs = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ErrorConfigs() {
        this.impersonating = false;
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.Validate = this.Validate.bind(this);
    }
    /**
     * Get a single error config.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/error-configs/get|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ErrorConfigs.prototype.Get = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/ErrorConfig", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an error config. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/error-configs/save|api docs} for more info
     *
     * @param errorConfig Required fields: DeliveryConfigID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ErrorConfigs.prototype.Save = function (errorConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/integrations/ErrorConfig", __assign(__assign({}, requestOptions), { data: errorConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an error config.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/error-configs/delete|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ErrorConfigs.prototype.Delete = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/integrations/ErrorConfig", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an error config.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/error-configs/patch|api docs} for more info
     *
     * @param errorConfig
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ErrorConfigs.prototype.Patch = function (errorConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/integrations/ErrorConfig", __assign(__assign({}, requestOptions), { data: errorConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validates an error config.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/error-configs/validate|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ErrorConfigs.prototype.Validate = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/integrations/ErrorConfig/validate", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ErrorConfigs.As().List() // lists ErrorConfigs using the impersonated users' token
     */
    ErrorConfigs.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ErrorConfigs;
}());
var ErrorConfigs$1 = new ErrorConfigs();

var IntegrationEvents = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function IntegrationEvents() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.Calculate = this.Calculate.bind(this);
        this.EstimateShipping = this.EstimateShipping.bind(this);
        this.SelectShipmethods = this.SelectShipmethods.bind(this);
        this.GetWorksheet = this.GetWorksheet.bind(this);
    }
    /**
     * Get a list of integration events.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrationEvents", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new integration event. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/create|api docs} for more info
     *
     * @param integrationEvent Required fields: CustomImplementationUrl, Name, HashKey
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.Create = function (integrationEvent, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/integrationEvents", __assign(__assign({}, requestOptions), { data: integrationEvent, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single integration event.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/get|api docs} for more info
     *
     * @param integrationEventID ID of the integration event.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.Get = function (integrationEventID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrationEvents/".concat(integrationEventID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an integration event. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/save|api docs} for more info
     *
     * @param integrationEventID ID of the integration event.
     * @param integrationEvent Required fields: CustomImplementationUrl, Name, HashKey
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.Save = function (integrationEventID, integrationEvent, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/integrationEvents/".concat(integrationEventID), __assign(__assign({}, requestOptions), { data: integrationEvent, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an integration event.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/delete|api docs} for more info
     *
     * @param integrationEventID ID of the integration event.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.Delete = function (integrationEventID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/integrationEvents/".concat(integrationEventID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an integration event.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/patch|api docs} for more info
     *
     * @param integrationEventID ID of the integration event.
     * @param integrationEvent
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.Patch = function (integrationEventID, integrationEvent, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/integrationEvents/".concat(integrationEventID), __assign(__assign({}, requestOptions), { data: integrationEvent, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Calculate an order.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/calculate|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.Calculate = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/calculate"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Estimate shipping cost.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/estimate-shipping|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.EstimateShipping = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/estimateshipping"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Select a ship method.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/select-shipmethods|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param orderShipMethodSelection
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.SelectShipmethods = function (direction, orderID, orderShipMethodSelection, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/orders/".concat(direction, "/").concat(orderID, "/shipmethods"), __assign(__assign({}, requestOptions), { data: orderShipMethodSelection, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single order worksheet.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/integration-events/get-worksheet|api docs} for more info
     *
     * @param direction Direction of the order, from the current user's perspective. Possible values: incoming, outgoing, all.
     * @param orderID ID of the order.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    IntegrationEvents.prototype.GetWorksheet = function (direction, orderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/orders/".concat(direction, "/").concat(orderID, "/worksheet"), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * IntegrationEvents.As().List() // lists IntegrationEvents using the impersonated users' token
     */
    IntegrationEvents.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return IntegrationEvents;
}());
var IntegrationEvents$1 = new IntegrationEvents();

var MessageSenders = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function MessageSenders() {
        this.impersonating = false;
        this.List = this.List.bind(this);
        this.Create = this.Create.bind(this);
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
        this.DeleteAssignment = this.DeleteAssignment.bind(this);
        this.ListAssignments = this.ListAssignments.bind(this);
        this.SaveAssignment = this.SaveAssignment.bind(this);
        this.ListCCListenerAssignments = this.ListCCListenerAssignments.bind(this);
        this.SaveCCListenerAssignment = this.SaveCCListenerAssignment.bind(this);
    }
    /**
     * Get a list of message senders.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/list|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.List = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/messagesenders", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new message sender. If ID is provided and an object with that ID already exists, a 409 (conflict) error is returned.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/create|api docs} for more info
     *
     * @param messageSender Required fields: Name, MessageTypes
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.Create = function (messageSender, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/messagesenders", __assign(__assign({}, requestOptions), { data: messageSender, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single message sender.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/get|api docs} for more info
     *
     * @param messageSenderID ID of the message sender.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.Get = function (messageSenderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/messagesenders/".concat(messageSenderID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a message sender. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/save|api docs} for more info
     *
     * @param messageSenderID ID of the message sender.
     * @param messageSender Required fields: Name, MessageTypes
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.Save = function (messageSenderID, messageSender, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/messagesenders/".concat(messageSenderID), __assign(__assign({}, requestOptions), { data: messageSender, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a message sender.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/delete|api docs} for more info
     *
     * @param messageSenderID ID of the message sender.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.Delete = function (messageSenderID, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/messagesenders/".concat(messageSenderID), __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a message sender.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/patch|api docs} for more info
     *
     * @param messageSenderID ID of the message sender.
     * @param messageSender
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.Patch = function (messageSenderID, messageSender, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/messagesenders/".concat(messageSenderID), __assign(__assign({}, requestOptions), { data: messageSender, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a message sender assignment.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/delete-assignment|api docs} for more info
     *
     * @param messageSenderID ID of the message sender.
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.supplierID ID of the supplier.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.DeleteAssignment = function (messageSenderID, listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/messagesenders/".concat(messageSenderID, "/assignments"), __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of message sender assignments.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/list-assignments|api docs} for more info
     *
     * @param listOptions.buyerID ID of the buyer.
     * @param listOptions.messageSenderID ID of the message sender.
     * @param listOptions.userID ID of the user.
     * @param listOptions.userGroupID ID of the user group.
     * @param listOptions.level Level of the message sender assignment. Possible values: User, Group, Company.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.supplierID ID of the supplier.
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.ListAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/messagesenders/assignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a message sender assignment.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/save-assignment|api docs} for more info
     *
     * @param messageSenderAssignment Required fields: MessageSenderID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.SaveAssignment = function (messageSenderAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/messagesenders/assignments", __assign(__assign({}, requestOptions), { data: messageSenderAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of message sender cc listener assignments.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/list-cclistener-assignments|api docs} for more info
     *
     * @param listOptions.search Word or phrase to search for.
     * @param listOptions.searchOn Comma-delimited list of fields to search on.
     * @param listOptions.sortBy Comma-delimited list of fields to sort by.
     * @param listOptions.page Page of results to return. Default: 1. When paginating through many items (> page 30), we recommend the "Last ID" method, as outlined in the Advanced Querying documentation.
     * @param listOptions.pageSize Number of results to return per page. Default: 20, max: 100.
     * @param listOptions.filters An object or dictionary representing key/value pairs to apply as filters. Valid keys are top-level properties of the returned model or 'xp.???'
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.ListCCListenerAssignments = function (listOptions, requestOptions) {
        if (listOptions === void 0) { listOptions = {}; }
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/messagesenders/CCListenerAssignments", __assign(__assign({}, requestOptions), { impersonating: impersonating, params: listOptions }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a message sender cc listener assignment.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/message-senders/save-cclistener-assignment|api docs} for more info
     *
     * @param messageCCListenerAssignment Required fields: MessageSenderAssignment, MessageType
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    MessageSenders.prototype.SaveCCListenerAssignment = function (messageCCListenerAssignment, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.post("/messagesenders/CCListenerAssignments", __assign(__assign({}, requestOptions), { data: messageCCListenerAssignment, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * MessageSenders.As().List() // lists MessageSenders using the impersonated users' token
     */
    MessageSenders.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return MessageSenders;
}());
var MessageSenders$1 = new MessageSenders();

var OrderSynchronization = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function OrderSynchronization() {
        this.impersonating = false;
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a single order sync.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/order-synchronization/get|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderSynchronization.prototype.Get = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/OrderSync", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update an order sync. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/order-synchronization/save|api docs} for more info
     *
     * @param orderSyncConfig Required fields: DeliveryConfigID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderSynchronization.prototype.Save = function (orderSyncConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/integrations/OrderSync", __assign(__assign({}, requestOptions), { data: orderSyncConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an order sync.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/order-synchronization/delete|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderSynchronization.prototype.Delete = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/integrations/OrderSync", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an order sync.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/order-synchronization/patch|api docs} for more info
     *
     * @param orderSyncConfig
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    OrderSynchronization.prototype.Patch = function (orderSyncConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/integrations/OrderSync", __assign(__assign({}, requestOptions), { data: orderSyncConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * OrderSynchronization.As().List() // lists OrderSynchronization using the impersonated users' token
     */
    OrderSynchronization.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return OrderSynchronization;
}());
var OrderSynchronization$1 = new OrderSynchronization();

var ProductSynchronization = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function ProductSynchronization() {
        this.impersonating = false;
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a single product sync.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/product-synchronization/get|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductSynchronization.prototype.Get = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/productsync", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a product sync. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/product-synchronization/save|api docs} for more info
     *
     * @param productSyncConfig Required fields: SyncProductChanged, SyncProductDeleted, DeliveryConfigID
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductSynchronization.prototype.Save = function (productSyncConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/integrations/productsync", __assign(__assign({}, requestOptions), { data: productSyncConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a product sync.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/product-synchronization/delete|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductSynchronization.prototype.Delete = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/integrations/productsync", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a product sync.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/product-synchronization/patch|api docs} for more info
     *
     * @param productSyncConfig
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    ProductSynchronization.prototype.Patch = function (productSyncConfig, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/integrations/productsync", __assign(__assign({}, requestOptions), { data: productSyncConfig, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * ProductSynchronization.As().List() // lists ProductSynchronization using the impersonated users' token
     */
    ProductSynchronization.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return ProductSynchronization;
}());
var ProductSynchronization$1 = new ProductSynchronization();

var SubscriptionIntegrations = /** @class */ (function () {
    /**
    * @ignore
    * not part of public api, don't include in generated docs
    */
    function SubscriptionIntegrations() {
        this.impersonating = false;
        this.Get = this.Get.bind(this);
        this.Save = this.Save.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Patch = this.Patch.bind(this);
    }
    /**
     * Get a single subscription integration.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/subscription-integrations/get|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionIntegrations.prototype.Get = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.get("/integrations/subscription", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update a subscription integration. If an object with the same ID already exists, it will be overwritten.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/subscription-integrations/save|api docs} for more info
     *
     * @param subscriptionIntegration Required fields: ApiClientID, HashKey
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionIntegrations.prototype.Save = function (subscriptionIntegration, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.put("/integrations/subscription", __assign(__assign({}, requestOptions), { data: subscriptionIntegration, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a subscription integration.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/subscription-integrations/delete|api docs} for more info
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionIntegrations.prototype.Delete = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.delete("/integrations/subscription", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update a subscription integration.
     * Check out the {@link https://ordercloud.io/api-reference/integrations/subscription-integrations/patch|api docs} for more info
     *
     * @param subscriptionIntegration
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    SubscriptionIntegrations.prototype.Patch = function (subscriptionIntegration, requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http.patch("/integrations/subscription", __assign(__assign({}, requestOptions), { data: subscriptionIntegration, impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * SubscriptionIntegrations.As().List() // lists SubscriptionIntegrations using the impersonated users' token
     */
    SubscriptionIntegrations.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return SubscriptionIntegrations;
}());
var SubscriptionIntegrations$1 = new SubscriptionIntegrations();

var UserInfo = /** @class */ (function () {
    /**
     * @ignore
     * not part of public api, don't include in generated docs
     */
    function UserInfo() {
        this.impersonating = false;
        this.GetToken = this.GetToken.bind(this);
    }
    /**
     * Get the identity token for an OrderCloud user. Used for Discover 2 integration.
     *
     * @param requestOptions.accessToken Provide an alternative token to the one stored in the sdk instance (useful for impersonation).
     * @param requestOptions.cancelToken Provide an [axios cancelToken](https://github.com/axios/axios#cancellation) that can be used to cancel the request.
     * @param requestOptions.requestType Provide a value that can be used to identify the type of request. Useful for error logs.
     */
    UserInfo.prototype.GetToken = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var impersonating;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impersonating = this.impersonating;
                        this.impersonating = false;
                        return [4 /*yield*/, http
                                .get("oauth/userinfo", __assign(__assign({}, requestOptions), { impersonating: impersonating }))
                                .catch(function (ex) {
                                if (ex.response) {
                                    throw new OrderCloudError(ex);
                                }
                                throw ex;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @description
     * enables impersonation by calling the subsequent method with the stored impersonation token
     *
     * @example
     * UserInfo.As().Get() // Gets userinfo token for the impersonated users' token
     */
    UserInfo.prototype.As = function () {
        this.impersonating = true;
        return this;
    };
    return UserInfo;
}());
var UserInfo$1 = new UserInfo();

export { Addresses$1 as Addresses, AdminAddresses$1 as AdminAddresses, AdminUserGroups$1 as AdminUserGroups, AdminUsers$1 as AdminUsers, ApiClients$1 as ApiClients, ApprovalRules$1 as ApprovalRules, Auth$1 as Auth, BundleLineItems$1 as BundleLineItems, BundleSubscriptionItems$1 as BundleSubscriptionItems, Bundles$1 as Bundles, Buyers$1 as Buyers, Cart$1 as Cart, Catalogs$1 as Catalogs, Categories$1 as Categories, Certs$1 as Certs, Configuration$1 as Configuration, CostCenters$1 as CostCenters, CreditCards$1 as CreditCards, DeliveryConfigurations$1 as DeliveryConfigurations, ErrorConfigs$1 as ErrorConfigs, ForgottenPassword$1 as ForgottenPassword, ImpersonationConfigs$1 as ImpersonationConfigs, Incrementors$1 as Incrementors, IntegrationEvents$1 as IntegrationEvents, InventoryRecords$1 as InventoryRecords, LineItems$1 as LineItems, Locales$1 as Locales, Me$1 as Me, MessageSenders$1 as MessageSenders, OpenIdConnects$1 as OpenIdConnects, OrderCloudError, OrderReturns$1 as OrderReturns, OrderSynchronization$1 as OrderSynchronization, Orders$1 as Orders, Payments$1 as Payments, PriceSchedules$1 as PriceSchedules, ProductCollections$1 as ProductCollections, ProductFacets$1 as ProductFacets, ProductSynchronization$1 as ProductSynchronization, Products$1 as Products, Promotions$1 as Promotions, SecurityProfiles$1 as SecurityProfiles, SellerApprovalRules$1 as SellerApprovalRules, Shipments$1 as Shipments, Specs$1 as Specs, SpendingAccounts$1 as SpendingAccounts, SubscriptionIntegrations$1 as SubscriptionIntegrations, SubscriptionItems$1 as SubscriptionItems, Subscriptions$1 as Subscriptions, SupplierAddresses$1 as SupplierAddresses, SupplierUserGroups$1 as SupplierUserGroups, SupplierUsers$1 as SupplierUsers, Suppliers$1 as Suppliers, tokenService as Tokens, TrackingEvents$1 as TrackingEvents, UserGroups$1 as UserGroups, UserInfo$1 as UserInfo, Users$1 as Users, Webhooks$1 as Webhooks, XpIndices$1 as XpIndices };
